import React from "react";
import { useDispatch } from "react-redux";
import { API_BASE } from "../../AppConfig";
import {
    BaseURL,
    GetHTMLColour,
    rgbToHex,
    shadeColor,
    getItemFromArray,
    toNumber,
    deepCopy,
} from "../../components/Common";
import {
    Vector3,
    MeshBuilder,
    StandardMaterial,
    CubeTexture,
    Color3,
    Texture,
    Layer,
    ArcRotateCamera,
    ShadowGenerator,
    SpotLight,
    DirectionalLight,
    HemisphericLight,
    Axis,
    Space,
    ActionManager,
    SceneLoader,
} from "@babylonjs/core";
import * as BABYLON from "babylonjs";
import "@babylonjs/loaders";
import "babylonjs-loaders";
// import 'babylonjs-materials';
import * as Materials from "@babylonjs/materials";
import { GLTF2Export } from "@babylonjs/serializers";
import * as GUI from "babylonjs-gui";
import { createTree } from "./babylon_assets/TreeGenerator";
import {
    GetRoofColoursAreasHTML,
    GetRoofColoursUndersideAreasHTML,
    GetSpecAllAreasColourHTML,
    GetSpecAllAreasAlpha,
} from "./PaperFunctions";
import { GetSpecAllAreas } from "./PaperFunctionHelper";
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import { updateGLB, uploadDocument } from "../../redux_store/jobState";
import tinycolor from "tinycolor2";

// import tex_crazypaving from './babylon_assets/crazypaving.jpg'; // Tell webpack this JS file uses this image

// import * as GUI from 'babylonjs-gui';
import Babylon3DScene from "./Babylon3DScene"; // ^^ point to file we created above or 'babylonjs-hook' NPM.
import * as APP from "../../redux_store/appState";
// import { ModelShape } from 'babylonjs/Particles/solidParticle';
// import { MeshAssetTask } from 'babylonjs/Misc/assetsManager';
// import './App.css';

let box;
var shadowGenerator;
var _scene_data = {
    added_objects: [],
};
var setGLB = false;

const onSceneReady = ({ scene, job, dispatch }) => {
    // This creates and positions a free camera (non-mesh)
    // var camera = new FreeCamera("camera1", new Vector3(0, 5, -10), scene);

    // // This targets the camera to scene origin
    // camera.setTarget(Vector3.Zero());

    const canvas = scene.getEngine().getRenderingCanvas();
    _scene_data.scene = scene;
    _scene_data.canvas = canvas;

    document.onvisibilitychange = function () {
        console.log("Visibility of page has changed!");
        if (_scene_data.scene) {
            const threeDMode = window?.app?.designer?.threeDMode;

            if (document.hidden || !threeDMode) {
                _scene_data.scene.getEngine().stopRenderLoop();
                console.log("bbylon paused");
            } else {
                console.log("bbylon started");
                _scene_data.scene.getEngine().runRenderLoop(() => {
                    if (typeof onRender === "function") {
                        onRender(_scene_data.scene, dispatch);
                    }
                    _scene_data.scene.render();
                });
            }
        }
    };

    // Add a camera to the scene and attach it to the canvas
    // var camera = new BABYLON.ArcRotateCamera("Camera", Math.PI / 2, Math.PI / 2.5, 1500, new BABYLON.Vector3(0, 0, 5), scene);
    var camera = new ArcRotateCamera("Camera", Math.PI / 2.05, Math.PI / 2.5, 1500, new Vector3(0, 0, 0), scene);
    camera.attachControl(canvas, true);
    camera.minZ = 5;
    camera.maxZ = 20000;
    camera.upperRadiusLimit = 5000;
    camera.lowerRadiusLimit = 10;
    camera.wheelPrecision = 0.75;
    camera.panningSensibility = 9;
    camera.targetScreenOffset = new BABYLON.Vector2(-80, 0);
    _scene_data.camera = camera;

    window._scene_data = {};
    window._scene_data.scene = scene;
    window._scene_data.camera = camera;

    // return;

    var skybox = MeshBuilder.CreateBox("skyBox", { size: 18000.0 }, scene);
    var skyboxMaterial = new StandardMaterial("skyBox", scene);
    skyboxMaterial.backFaceCulling = false;
    skyboxMaterial.reflectionTexture = new CubeTexture(BaseURL("textures/test/TropicalSunnyDay"), scene);
    skyboxMaterial.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
    skyboxMaterial.diffuseColor = new Color3(0, 0, 0);
    skyboxMaterial.specularColor = new Color3(0, 0, 0);
    skybox.material = skyboxMaterial;

    var skybox2 = MeshBuilder.CreateBox("skyBox2", { size: 10000.0 }, scene);
    var skyboxMaterial2 = new StandardMaterial("skyBox2", scene);
    skyboxMaterial2.backFaceCulling = false;
    // skyboxMaterial2.reflectionTexture = new BABYLON.CubeTexture("textures/skybox", scene);
    skyboxMaterial2.reflectionTexture = new CubeTexture(BaseURL("textures/test/TropicalSunnyDay"), scene);
    skyboxMaterial2.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE;
    skyboxMaterial2.diffuseColor = new Color3(0, 0, 0);
    skyboxMaterial2.specularColor = new Color3(0, 0, 0);
    skyboxMaterial2.alpha = 0.5;
    skybox2.rotation.y += Math.PI;
    skybox2.material = skyboxMaterial2;

    var run_sky_backwards = false;
    scene.registerBeforeRender(function () {
        if (run_sky_backwards) skybox2.rotation.y -= 0.0005;
        else skybox2.rotation.y += 0.0005;
    });

    skybox.isVisible = false;
    _scene_data.skybox = skybox;
    skybox2.isVisible = false;
    _scene_data.skybox2 = skybox2;

    var background = new Layer("background", BaseURL("models/textures/bg.jpg"), scene, true);
    background.isBackground = true;
    background.isVisible = true;
    _scene_data.background = background;

    // Add and manipulate meshes in the scene
    var ground = BABYLON.MeshBuilder.CreateDisc("grass", { radius: 5000, arc: 1, tessellation: 24 }, scene);
    ground.rotate(BABYLON.Axis.X, Math.PI / 2, BABYLON.Space.WORLD);
    ground.rotate(BABYLON.Axis.Y, -Math.PI * 1.1, BABYLON.Space.WORLD);
    ground.rotate(BABYLON.Axis.Z, -Math.PI * 1.1, BABYLON.Space.LOCAL);
    ground.position = new BABYLON.Vector3(0, -1210 * 0.1, 0);
    ground.receiveShadows = true;
    ground.isVisible = false;
    ground.backFaceCulling = true;
    ground.isPickable = false;

    var mat = new BABYLON.StandardMaterial("grass", scene);
    mat.ambientTexture = new BABYLON.Texture(BaseURL("images/grass.jpg"), scene);
    mat.ambientTexture.uScale = 15.0;
    mat.ambientTexture.vScale = 15.0;
    mat.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);
    mat.backFaceCulling = true;
    ground.material = mat;

    _scene_data.ground = ground;
    window._scene_data.ground = ground;

    var ground_grid = BABYLON.MeshBuilder.CreateDisc("grid", { radius: 8000, arc: 1, tessellation: 24 }, scene);
    ground_grid.rotate(BABYLON.Axis.X, Math.PI / 2, BABYLON.Space.WORLD);
    ground_grid.rotate(BABYLON.Axis.Y, -Math.PI * 1.1, BABYLON.Space.WORLD);
    ground_grid.rotate(BABYLON.Axis.Z, -Math.PI * 1.1, BABYLON.Space.LOCAL);
    ground_grid.position = new BABYLON.Vector3(0, -1210 * 0.1, 0);
    ground_grid.receiveShadows = true;
    ground_grid.isVisible = true;
    ground_grid.backFaceCulling = true;
    ground_grid.isPickable = false;

    var groundMaterial = new Materials.GridMaterial("groundMaterial", scene);
    groundMaterial.majorUnitFrequency = 10;
    groundMaterial.minorUnitVisibility = 0.2;
    groundMaterial.gridRatio = 10;
    groundMaterial.opacity = 0.8;
    groundMaterial.backFaceCulling = true;
    groundMaterial.mainColor = new BABYLON.Color3(0, 0.05, 0.1);
    groundMaterial.lineColor = new BABYLON.Color3(0, 1.0, 1.0);
    ground_grid.material = groundMaterial;
    _scene_data.ground_grid = ground_grid;
    window._scene_data.ground_grid = ground_grid;

    var grid_ground = BABYLON.MeshBuilder.CreateDisc("grid_ground", { radius: 8000, arc: 1, tessellation: 24 }, scene);
    grid_ground.rotate(BABYLON.Axis.X, Math.PI / 2, BABYLON.Space.WORLD);
    grid_ground.rotate(BABYLON.Axis.Y, -Math.PI * 1.1, BABYLON.Space.WORLD);
    grid_ground.rotate(BABYLON.Axis.Z, -Math.PI * 1.1, BABYLON.Space.LOCAL);
    grid_ground.position = new BABYLON.Vector3(0, -1250 * 0.1, 0);
    grid_ground.receiveShadows = true;
    grid_ground.isVisible = true;
    grid_ground.backFaceCulling = true;
    grid_ground.isPickable = false;
    grid_ground.alphaIndex = 0;
    _scene_data.grid_ground = grid_ground;
    window._scene_data.grid_ground = grid_ground;

    var mat2 = new BABYLON.StandardMaterial("grid_ground", scene);
    mat2.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);
    mat2.backFaceCulling = true;
    mat2.alpha = 0.4;
    mat2.ambientColor = window.BABYLON.Color3.FromHexString("#444444");
    mat2.diffuseColor = window.BABYLON.Color3.FromHexString("#444444");
    grid_ground.material = mat2;

    _scene_data.grid_ground = grid_ground;
    window._scene_data.grid_ground = grid_ground;

    scene.activeCamera = camera;
    let camera_is_under = false;
    camera.onViewMatrixChangedObservable.add(function () {
        // console.log(camera.position.y);
        var ground = scene.getMeshByName("ground");
        if (ground) {
            if (camera_is_under && camera.position.y > 0) {
                camera_is_under = !camera_is_under;
                ground.isPickable = true;
            } else if (!camera_is_under && camera.position.y < 0) {
                camera_is_under = !camera_is_under;
                ground.isPickable = false;
            }
        }
    });

    // Add lights to the scene
    var light1 = new HemisphericLight("light1", new Vector3(1, 1, 0), scene);
    // var light2 = new BABYLON.PointLight("light2", new BABYLON.Vector3(150, 1000, 150), scene);
    light1.intensity = 0.6;
    window._scene_data.hemisphere_light = light1;

    var direction_light = new DirectionalLight("dirLight", new Vector3(1, -1, -0.5), scene);
    direction_light.intensity = 0.8;
    direction_light.position = new Vector3(-1000, 1000, 1000);
    window._scene_data.direction_light = direction_light;

    scene.registerBeforeRender(function () {
        // direction_light.direction.x -= 0.01;
    });

    //Light direction is directly down from a position one unit up, slow decay
    var torch = new SpotLight("spotLight", new Vector3(-1, 1, -1), new Vector3(0, -1, 0), Math.PI / 2, 30, scene);
    torch.diffuse = new Color3(0.5, 0.5, 0.5);
    torch.position = camera.position;
    torch.specular = new Color3(0.5, 0.5, 0.5);
    torch.intensity = 0.8;

    scene.registerBeforeRender(function () {
        torch.position = camera.position;
        torch.setDirectionToTarget(new BABYLON.Vector3(0, 0, 0));
    });

    // Shadows
    shadowGenerator = new ShadowGenerator(2048, direction_light);
    shadowGenerator.bias = 0.002;
    shadowGenerator.normalBias = 0.05;
    direction_light.shadowMaxZ = 6000;
    direction_light.shadowMinZ = 0;
    shadowGenerator.useBlurExponentialShadowMap = true;
    shadowGenerator.blurBoxOffset = 16;
    shadowGenerator.blurScale = 4;
    shadowGenerator.useKernelBlur = true;
    shadowGenerator.blurKernel = 256;
    shadowGenerator.useContactHardeningShadow = true;
    shadowGenerator.contactHardeningLightSizeUVRatio = 0.02;
    shadowGenerator.setDarkness(0.1);
    shadowGenerator.transparencyShadow = true;
    shadowGenerator.enableSoftTransparentShadow = true;
    shadowGenerator.usePoissonSampling = true;
    shadowGenerator.usePercentageCloserFiltering = true;

    _scene_data.shadowGenerator = shadowGenerator;
    window._scene_data.shadowGenerator = shadowGenerator;

    var advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("ui1", true, scene);
    var label = new GUI.Rectangle("label for Ball");
    label.background = "black";
    label.height = "1px";
    label.alpha = 0.0;
    label.width = "400px";
    label.cornerRadius = 20;
    label.thickness = 1;
    label.linkOffsetY = 30;
    label.left = "10";
    label.top = "220";
    label.right = "200";
    label.zIndex = 5;
    label.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
    label.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
    label.isVisible = true;
    var text1 = new GUI.TextBlock();
    text1.text = "";
    text1.color = "white";
    label.addControl(text1);
    advancedTexture.addControl(label);
    var join_line = new GUI.Line();
    join_line.alpha = 0.5;
    join_line.lineWidth = 3;
    join_line.dash = [3, 6];
    advancedTexture.addControl(join_line);
    join_line.connectedControl = label;
    join_line.isVisible = false;

    _scene_data.join_line = join_line;

    var highlighter = new window.BABYLON.HighlightLayer("hightlighter2", scene);
    highlighter.innerGlow = true;

    var alpha = 0;
    scene.registerBeforeRender(() => {
        alpha += 0.09;

        highlighter.blurHorizontalSize = 0.3 + Math.cos(alpha) * 0.3 + 0.6;
        highlighter.blurVerticalSize = 0.3 + Math.sin(alpha / 3) * 0.3 + 0.6;
    });
    _scene_data.highlighter = highlighter;

    // to manage background clicks to the skbox to remove all selections
    scene.onPointerObservable.add((pointerInfo) => {
        if (
            pointerInfo.type === BABYLON.PointerEventTypes.POINTERPICK ||
            (pointerInfo.type === 32 && _scene_data.last_pointerInfo_type !== BABYLON.PointerEventTypes.POINTERPICK)
        ) {
            if (
                !pointerInfo.pickInfo.hit ||
                ["skyBox", "skyBox2", "ground", "grass", "paving"].includes(pointerInfo.pickInfo.pickedMesh.id)
            ) {
                var mesh_picked = _scene_data.mesh_picked;
                if (mesh_picked) {
                    if (_scene_data.highlighter) _scene_data.highlighter.removeMesh(mesh_picked);
                    if (mesh_picked.material.alpha < 0.5) {
                        if (mesh_picked.metadata) {
                            if (mesh_picked.metadata.last_edgeRendererEnabled) mesh_picked.enableEdgesRendering(0.999);
                            else mesh_picked.disableEdgesRendering();
                            if (mesh_picked.metadata.last_edgesColor)
                                mesh_picked.edgesColor = mesh_picked.metadata.last_edgesColor;
                            if (mesh_picked.metadata.last_edgesWidth)
                                mesh_picked.edgesWidth = mesh_picked.metadata.last_edgesWidth;
                        } else {
                            mesh_picked.disableEdgesRendering();
                        }
                    } else {
                        if (mesh_picked.metadata) {
                            if (mesh_picked.metadata.last_edgeRendererEnabled) mesh_picked.enableEdgesRendering(0.999);
                            else mesh_picked.disableEdgesRendering();
                            if (mesh_picked.metadata.last_edgesColor)
                                mesh_picked.edgesColor = mesh_picked.metadata.last_edgesColor;
                            if (mesh_picked.metadata.last_edgesWidth)
                                mesh_picked.edgesWidth = mesh_picked.metadata.last_edgesWidth;
                        }
                    }
                    mesh_picked.isPickable = true;
                }
                mesh_picked = null;
                if (join_line) join_line.isVisible = false;
                if (label) label.isVisible = true;
                // _scene_data.handleStateChange({ selected_item: null });

                // _scene_data.update3DDesigner(APP.BABYLON_SELECTED_ITEM, null);
                // _scene_data.gizmoManager.attachToMesh(null);
                _scene_data.mesh_picked = mesh_picked;
            }
        }
        _scene_data.last_pointerInfo_type = pointerInfo.type;
    });
};

export const zoomIn3D = () => {
    var activCam = _scene_data.scene.activeCamera;
    var ease = new BABYLON.CubicEase();
    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    var activCam = _scene_data.scene.activeCamera;
    BABYLON.Animation.CreateAndStartAnimation(
        "at5",
        activCam,
        "radius",
        90,
        15,
        activCam.radius,
        activCam.radius / 1.2,
        0,
        ease
    );

    // var activCam = _scene_data.scene.activeCamera;
    // activCam.radius = activCam.radius / 1.2;
};

export const GenerateARModal = async (dispatch, threeDMode) => {
    setGLB = true;

    // Check if the scene has been updated, or page not in 3D Mode
    if (_scene_data?.scene?.importedMeshesFiles?.length < 1 || !threeDMode) {
        // Toggle 3D Mode.
        // To generate te modal, the engine needs to start. Open 3d Modal view.
        dispatch(APP.toggleDesigner(APP.THREED_MODE));
    }
};

export const zoomOut3D = () => {
    // var activCam = _scene_data.scene.activeCamera;
    // activCam.radius = activCam.radius * 1.2;
    var ease = new BABYLON.CubicEase();
    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    var activCam = _scene_data.scene.activeCamera;
    BABYLON.Animation.CreateAndStartAnimation(
        "at5",
        activCam,
        "radius",
        90,
        15,
        activCam.radius,
        activCam.radius * 1.2,
        0,
        ease
    );
};

export const zoomAll3D = () => {
    if (_scene_data.loading) return;
    var camera = _scene_data.scene.activeCamera;
    camera.zoomOn(_scene_data.loaded_meshes);
    let width = _scene_data.canvas.width;
    let height = _scene_data.canvas.height;
    if (window.threed_mini_mode) {
        if (window.threed_mini_mode === true) {
            if (window.threed_mini_height) height = window.threed_mini_height;
            width = window.innerWidth - 400;
        } else {
            if (window.threed_mini_width) width = window.threed_mini_width;
            height = window.innerHeight - 100;
        }
    }
    let ratio = width / height;
    console.log("zoomAll3D", camera.z, camera.radius, width, height, ratio, window.threed_mini_mode);

    if (ratio > 2 && window.threed_mini_mode === true) {
        // ratio = ratio -;
        if (ratio > 5) ratio = 5;
        ratio += 0.5;
        ratio = ratio * 0.3;
        if (ratio > 1) camera.radius = camera.radius / ratio;
    }
    camera.minZ = 1;
    camera.maxZ = 25000;
    camera.upperRadiusLimit = 6000;
    camera.lowerRadiusLimit = 3;
    camera.wheelPrecision = 0.75;
    camera.panningSensibility = 9;
    // activCam.radius = 1500;
};

const load_Plan = (floor_group) => {
    // Add and manipulate meshes in the scene
    var scene = _scene_data.scene;

    var scale = 0.15;

    let width = floor_group.getBoundingInfo().boundingBox.maximum.x;
    let height = floor_group.getBoundingInfo().boundingBox.maximum.y;

    if (window?.job?.DesignParameters?.DeckMode) {
        console.log("width, height floor, ", "DECKMODE");
        console.log("width, height floor, ", window?.job?.AreaSpecifications);
        if (window?.job?.AreaSpecifications && window?.job?.AreaSpecifications.length === 1) {
            if (width < window?.job?.AreaSpecifications[0]?.SHAPE?.Depth) {
                width = window?.job?.AreaSpecifications[0]?.SHAPE?.Depth;
            }
            if (height < window?.job?.AreaSpecifications[0]?.SHAPE?.Length) {
                height = window?.job?.AreaSpecifications[0]?.SHAPE?.Length;
            }
        }
    }
    console.log("width, height floor, ", width, height);

    var paving = BABYLON.MeshBuilder.CreateGround(
        "paving",
        {
            width: width * scale,
            height: height * scale,
            subdivisions: 2,
        },
        scene
    );

    // bricks.rotate(BABYLON.Axis.Y, -(Math.PI * 0.983), BABYLON.Space.WORLD);
    paving.position = new BABYLON.Vector3(0, -1205 * 0.1, 0);
    paving.receiveShadows = true;
    // ground.isPickable = false;

    var mat2 = new BABYLON.StandardMaterial("paving", scene);
    // mat.ambientTexture = new BABYLON.Texture("images/draw house outline.png", scene);
    // mat.ambientTexture = new BABYLON.Texture("images/20190302_WGS84_S_Mercator_138_57260_-34_93000_138_57356_-34_92956_21.jpg", scene);
    mat2.ambientTexture = new BABYLON.Texture(BaseURL("models/textures/floor_paving1.jpg"), scene);
    // console.log("tex_crazypaving",tex_crazypaving);
    mat2.ambientTexture.uScale = floor_group.getBoundingInfo().boundingBox.maximum.x / 1000;
    mat2.ambientTexture.vScale = floor_group.getBoundingInfo().boundingBox.maximum.y / 1000;
    mat2.specularColor = new BABYLON.Color3(0.2, 0.2, 0.2);
    paving.material = mat2;
    paving.isPickable = false;
    paving.isVisible = false;
    if (_scene_data.display_mode === "Grid") paving.isVisible = false;
    BABYLON.Tags.AddTagsTo(paving, "paving");
    _scene_data.paving = paving;
    window._scene_data.paving = paving;

    if (_scene_data.spriteManagerLogo) {
        _scene_data.spriteManagerLogo.dispose();
        _scene_data.spriteManagerLogo = null;
    }

    if (!_scene_data.spriteManagerLogo && window.FIELDERS)
        _scene_data.spriteManagerLogo = new BABYLON.SpriteManager(
            "logoManager",
            BaseURL("models/textures/" + "centenary_logo.png"),
            20,
            { width: 850, height: 288 },
            scene
        );
    if (!_scene_data.spriteManagerLogo && window.LYSAGHT)
        _scene_data.spriteManagerLogo = new BABYLON.SpriteManager(
            "logoManager",
            BaseURL("models/textures/" + "lysaght_logo_model.png"),
            20,
            { width: 797, height: 433 },
            scene
        );
    // const logo = new BABYLON.Sprite("logo", spriteManagerLogo);
    // logo.width = 200;
    // logo.height = logo.width/2.95;
    // logo.position.y = -60;

    floor_group._children.forEach(function (el) {
        console.log("adding sprite for ", el);
        // console.log(el.getBoundingInfo());
        // console.log(el.getBoundingInfo().boundingBox.center);
        const logo = new BABYLON.Sprite("logo", _scene_data.spriteManagerLogo);
        if (window.FIELDERS) {
            logo.width = 200;
            logo.height = logo.width / 2.95;
            logo.color.a = 0.65;
            // logo.position.y = -60;
            let height = -60;
            if (window?.job?.DesignParameters?.DeckMode) height = 20;
            logo.position = new Vector3(
                floor_group.getBoundingInfo().boundingBox.center.x * 0.1 -
                    el.getBoundingInfo().boundingBox.center.x / 10,
                height,
                floor_group.getBoundingInfo().boundingBox.center.y * 0.1 -
                    el.getBoundingInfo().boundingBox.center.y / 10
            );
        }
        if (window.LYSAGHT) {
            logo.width = 200;
            logo.height = logo.width / 1.84;
            // logo.position.y = -60;
            let height = -30;
            if (window?.job?.DesignParameters?.DeckMode) height = 40;
            logo.position = new Vector3(
                floor_group.getBoundingInfo().boundingBox.center.x * 0.1 -
                    el.getBoundingInfo().boundingBox.center.x / 10,
                height,
                floor_group.getBoundingInfo().boundingBox.center.y * 0.1 -
                    el.getBoundingInfo().boundingBox.center.y / 10
            );
        }
        // console.log(logo.position);
    });
};

/**
 * Will run on every frame render.  We are spinning the box on y-axis.
 */

export const getElementsToClear = (scene) => {
    let elements_to_dispose = [];
    if (_scene_data.paving) {
        _scene_data.paving.dispose();
        _scene_data.paving = null;
    }

    if (_scene_data.loaded_meshes) {
        _scene_data.loaded_meshes.forEach(function (mesh) {
            elements_to_dispose.push(mesh);
        });
    }
    _scene_data.scene.meshes.forEach(function (el) {
        if (el.name.includes("skyBox") || el.name.includes("grid") || el.name.includes("grass")) {
            // console.log(el.name, "nothing");
            //nothing
        } else {
            // console.log(el.name, "dispose");
            elements_to_dispose.push(el);
        }
    });

    if (_scene_data?.scene?.meshes?.length)
        for (var i = 0; i < _scene_data.scene.meshes.length; i++) {
            let el = _scene_data.scene.meshes?.[i];
            if (el) {
                if (el.name.includes("skyBox") || el.name.includes("grid") || el.name.includes("grass")) {
                } else {
                    // el.dispose();
                    elements_to_dispose.push(el);
                    // i--;
                }
            }
        }

    if (_scene_data.join_line) _scene_data.join_line.isVisible = false;

    if (_scene_data.spriteManagerLogo)
        _scene_data.spriteManagerLogo.children.forEach(function (el) {
            // el.isVisible = false;
            elements_to_dispose.push(el);
            // el.dispose();
        });
    return elements_to_dispose;
};

export const clearScene = (scene) => {
    if (_scene_data.paving) {
        _scene_data.paving.dispose();
        _scene_data.paving = null;
    }

    if (_scene_data.loaded_meshes) {
        _scene_data.loaded_meshes.forEach(function (mesh) {
            mesh.dispose();
        });
    }
    _scene_data.scene.meshes.forEach(function (el) {
        if (el.name.includes("skyBox") || el.name.includes("grid") || el.name.includes("grass")) {
            // console.log(el.name, "nothing");
            //nothing
        } else {
            // console.log(el.name, "dispose");
            el.dispose();
        }
    });

    if (_scene_data?.scene?.meshes?.length)
        for (var i = 0; i < _scene_data.scene.meshes.length; i++) {
            let el = _scene_data.scene.meshes?.[i];
            if (el) {
                if (el.name.includes("skyBox") || el.name.includes("grid") || el.name.includes("grass")) {
                } else {
                    el.dispose();
                    i--;
                }
            }
        }

    if (_scene_data.join_line) _scene_data.join_line.isVisible = false;

    if (_scene_data.spriteManagerLogo)
        _scene_data.spriteManagerLogo.children.forEach(function (el) {
            el.isVisible = false;
            el.dispose();
        });
};

// var loaded_meshes;

const loadModelError = (error, param2) => {
    console.log("loadModelError", error, param2);
};
const onLoadModel = ({ scene, model, url_base = null, onError = loadModelError, dispatch, job }) => {
    if (url_base === null) url_base = API_BASE() + "obj/";
    if (!scene) scene = _scene_data.scene;
    if (scene.loading && scene.loadingModel && scene.loadingModel === model) return;
    scene.getEngine().stopRenderLoop();
    scene.loading = true;
    // clearScene(scene);
    let elements_to_dispose = getElementsToClear(scene);
    // console.log("loadedModel", loadedModel);
    // if (loadedModel) loadedModel.isVisible = false;

    // window.BABYLON.OBJFileLoader.IMPORT_VERTEX_COLORS = true;
    // window.BABYLON.OBJFileLoader.COMPUTE_NORMALS = true;
    // window.BABYLON.OBJFileLoader.INVERT_Y = true;
    // window.BABYLON.OBJFileLoader.INVERT_TEXTURE_Y = true;
    // window.BABYLON.OBJFileLoader.MATERIAL_LOADING_FAILS_SILENTLY = false;
    // window.BABYLON.OBJFileLoader.SKIP_MATERIALS = true;

    // if (loadedModel) loadedModel.dispose();
    SceneLoader.ImportMesh(
        null,
        url_base,
        model,
        scene,
        function (meshes) {
            try {
                var floor_group = new BABYLON.Mesh("floor", scene);

                var getMinMax = function (mesh) {
                    var info = mesh.getBoundingInfo().boundingBox;
                    var min = info.minimumWorld;
                    var max = info.maximumWorld;
                    return { min: min, max: max };
                };
                floor_group.refreshBoundingInfo = function () {
                    var children = this.getChildren();
                    //children[0].refreshBoundingInfo();
                    var mm = getMinMax(children[0]);
                    var min = mm.min;
                    var max = mm.max;
                    for (var i = 1; i < children.length; i++) {
                        //children[i].refreshBoundingInfo();
                        mm = getMinMax(children[i]);
                        min = BABYLON.Vector3.Minimize(min, mm.min);
                        max = BABYLON.Vector3.Maximize(max, mm.max);
                    }
                    this.setBoundingInfo(new BABYLON.BoundingInfo(min, max));
                };

                for (var mesh of meshes) {
                    if (mesh.id.includes("group_6")) mesh.parent = floor_group;
                }
                floor_group.refreshBoundingInfo();
                // floor_group.showBoundingBox = true;

                let floor = meshes[0];
                let floor_width = floor.getBoundingInfo().boundingBox.extendSize.x;
                let floor_depth = floor.getBoundingInfo().boundingBox.extendSize.y;
                let floor_length = floor.getBoundingInfo().boundingBox.extendSize.z;

                meshes.forEach(function (el) {
                    el.isVisible = false;
                });

                // floor.receiveShadows = true;
                // floor.isPickable = false;

                // for (var mesh of meshes) {
                //     if (mesh.id.includes("group_6")
                //         //   || mesh.id.includes("_mm2")
                //         //   || mesh.id.includes("_mm3")
                //         //   || mesh.id.includes("group_1")
                //         //   || mesh.id.includes("_mm1")
                //     ) mesh.dispose();
                // };
                meshes = meshes.filter(
                    (item) => !item.id.includes("group_6")
                    //   && !item.id.includes("_mm2")
                    //   && !item.id.includes("_mm3")
                    //   && !item.id.includes("group_1")
                    //   && !item.id.includes("_mm1")
                );

                // _scene_data.gazebo_meshes = meshes;

                _scene_data.floor_group = floor_group;
                _scene_data.loaded_meshes = [];

                // for (var mesh of meshes) {
                //     // ( copy and rotate the meshes to fix rendering issue )
                //     const mesh2 = mesh.clone(mesh.id);
                //     mesh2.rotation.x = Math.PI; // Rotate 180
                // }

                for (var mesh of meshes) {
                    // if (mesh.id.includes("_mm1")) {mesh.dispose()};
                    // if (mesh.id.includes("_mm3")) mesh.isVisible = false;
                    // if (mesh.id.includes("_mm2")) mesh.isVisible = false;
                    // if (mesh.id.includes("group_1")) mesh.isVisible = false;
                    // Set backface curlling
                    mesh.backFaceCulling = false;
                    _scene_data.loaded_meshes.push(mesh);

                    mesh.rotate(Axis.X, -Math.PI / 2, Space.WORLD).scaling = new Vector3(-0.1, 0.1, 0.1);
                    mesh.position = new Vector3(
                        floor_group.getBoundingInfo().boundingBox.center.x * 0.1,
                        -120,
                        floor_group.getBoundingInfo().boundingBox.center.y * 0.1
                    );
                    // mesh.scaling = new Vector3(floor.getBoundingInfo().boundingBox.center.x, 0, 0);
                    mesh.backFaceCulling = false;
                    mesh.receiveShadows = true;
                    if (mesh.material && mesh.material.clone) mesh.material = mesh.material.clone(mesh.id);
                    mesh.material.backFaceCulling = false;
                    mesh.data = {};
                    //"group_4 group_all area_1 sheet_section sheet_section_1_8 objectdata,sel_type:sheet,centroid:(4890.00/1475.00),ref:Flat$Roof/4940.00,colour:Vanilla/Vanilla,material:Corrugated$-$C/Bond$0.42$(No$Foot$Traffic)"
                    var ind = mesh.id.indexOf("objectdata");
                    if (ind > -1) {
                        let base_data = mesh.id.substring(0, ind);
                        let base_data_split = base_data.split(" ");
                        let data = {
                            areaNumber: -1,
                            areaIndex: -1,
                            ref: "",
                            lengthQQ: 0,
                            babylon: true,
                        };

                        for (var item of base_data_split) {
                            let item_split = item.split("_");
                            if (item_split[0] === "len") data.lengthQQ = Number(item_split[1]);
                            else if (item_split[0] === "area") {
                                data["areaNumber"] = item_split.length > 1 ? Number(item_split[1]) : 1;
                                data["areaIndex"] = item_split.length > 1 ? Number(item_split[1]) - 1 : 0;
                            } else if (item_split[0] === "sheet") data.sel_type = "sheet";
                            else if (item === "beam4") data.typeQQ = "beam4";
                            else if (item === "beam3") data.typeQQ = "beam3";
                            else if (item === "LeftBeam") {
                                data.LeftBeam = 1;
                                data.typeQQ = "beam2";
                            } else if (item === "RightBeam") {
                                data.RightBeam = 1;
                                data.typeQQ = "beam2";
                            } else if (item === "beam2") data.typeQQ = "beam2";
                            else if (item === "beam1") data.typeQQ = "beam1";
                            else if (item === "attach_fascia") data.typeQQ = "attachment_fascia";
                            else if (item === "attach_gutter") data.typeQQ = "attachment_gutter";
                            else if (item === "infill_1_beam") data.typeQQ = "infill_1_beam";
                            else if (item === "infill_2_beam") data.typeQQ = "infill_2_beam";
                            else if (item === "slat_panel") data.sel_type = "slat_panel";
                            else if (item_split[0] === "beam") {
                                data.sel_type = "beam";
                                if (item_split.length > 1) {
                                    data.beam_name = item_split[1];
                                }
                            } else if (item_split[0] === "attachment") data.sel_type = "attachment";
                            else if (item_split[0] === "attachment_roof") data.sel_type = "attachment_roof";
                            else if (item_split[0] === "gutter") data.sel_type = "gutter";
                            else if (item_split[0] === "barge") data.sel_type = "barge_cap";
                            else if (item_split[0] === "barge_cap") data.sel_type = "barge_cap";
                            else if (item_split[0] === "ridge") data.sel_type = "ridge";
                            else if (item_split[0] === "post") data.sel_type = "post";
                            else if (item_split[0] === "downpipe") data.sel_type = "downpipe";
                            else if (item_split[0] === "slat" && item_split?.[1] === "post")
                                data.sel_type = "slat_post";
                            else if (item_split[0] === "infill") {
                                if (item_split.length > 2 && item_split[2] === "1") data.sel_type = "infill_1";
                                if (item_split.length > 2 && item_split[2] === "2") data.sel_type = "infill_2";
                                else data.sel_type = "infill_1";
                            } else data[item_split[0]] = item_split.length > 1 ? item_split[1] : item_split[0];
                        }

                        let this_data = mesh.id.substring(ind, mesh.id.length);
                        let data_split = this_data.split(",");

                        for (var item of data_split) {
                            let item_split = item.split(":");
                            if (item_split.length > 1 && item_split[1].replaceAll)
                                item_split[1] = item_split[1].replaceAll("$", " ");
                            if (item_split[0] === "len") data.lengthQQ = Number(item_split[1]);
                            else if (item_split[0] === "area") {
                                data["areaNumber"] = item_split.length > 1 ? Number(item_split[1]) : 1;
                                data["areaIndex"] = item_split.length > 1 ? Number(item_split[1]) - 1 : 0;
                            } else if (data["sel_type"] && item_split[0] === "sel_type") {
                                if (item_split[1].length > 0)
                                    data["sel_type"] = item_split.length > 1 ? item_split[1] : item_split[0];
                            } else if (item_split[0] === "type")
                                data["typeQQ"] = item_split.length > 1 ? item_split[1] : item_split[0];
                            else if (item_split[0] === "name")
                                data["nameQQ"] = item_split.length > 1 ? item_split[1] : item_split[0];
                            else if (item_split[0] === "Extra") data["Extra"] = true;
                            else if (item === "infill_1_beam") data.typeQQ = "infill_1_beam";
                            else if (item === "infill_2_beam") data.typeQQ = "infill_2_beam";
                            else data[item_split[0]] = item_split.length > 1 ? item_split[1] : item_split[0];
                        }
                        if (data?.sel_type?.startsWith("beam")) data.is_beam = true;
                        if (["sheet", "skylight"].includes(data.sel_type)) data.is_roofsheet = true;
                        if (["sheed_end", "skylight_end"].includes(data.sel_type)) data.is_roofsheet_end = true;
                        if (["sheet_side", "skylight_side"].includes(data.sel_type)) data.is_roofsheet_side = true;
                        if (["skylight"].includes(data.sel_type)) data.is_skylight = true;
                        if (["slat_panel"].includes(data.sel_type)) data.is_slat = true;
                        if (["brace"].includes(data.sel_type)) data.is_brace = true;
                        if (["back_channel"].includes(data.sel_type)) data.is_backchannel = true;
                        if (["attachment"].includes(data.sel_type)) {
                            data.is_attachment = true;
                        }
                        if (["attachment_roof"].includes(data.sel_type)) data.is_attachment_roof = true;

                        if (data.is_attachment_roof || data.is_attachment) {
                            if (data.ref === "unknown") {
                                if (data.ref2.startsWith("CBR")) data.ref = "BackRight-Attachment";
                                if (data.ref2.startsWith("CBM")) data.ref = "BackMid-Attachment";
                                if (data.ref2.startsWith("CBL")) data.ref = "BackLeft-Attachment";
                                if (data.ref2.startsWith("CFR")) data.ref = "FrontRight-Attachment";
                                if (data.ref2.startsWith("CFL")) data.ref = "FrontLeft-Attachment";
                            }
                        }

                        if (data?.ref2 && (data.ref2.startsWith("CB") || data.ref2.startsWith("CF"))) {
                            data.is_cutout = true;
                        }

                        if (["gutter"].includes(data.sel_type)) data.is_gutter = true;
                        if (data.is_gutter && mesh?.material?.ambientTexture?.url.includes("gutter_d.jpg")) {
                            data.is_gutter_face = true;
                        }
                        if (data?.sel_type && data.sel_type.includes("infill")) {
                            data.is_infill = true;
                            if (data.sel_type === "infill_1") {
                                let normals = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
                                if (normals[0] > 0) {
                                    //need to reverse normals  where black sheet DES-2160
                                    let new_normals = [];
                                    for (let n of normals) {
                                        new_normals.push(-n);
                                    }
                                    mesh.setVerticesData(BABYLON.VertexBuffer.NormalKind, new_normals);
                                    mesh.updateVerticesData(BABYLON.VertexBuffer.NormalKind, new_normals);
                                }
                            }
                        }
                        if (["barge_cap"].includes(data.sel_type)) data.is_barge = true;
                        if (["ridge"].includes(data.sel_type)) data.is_ridge = true;

                        if (data.typeQQ === "slat_post") item.sel_type = "slat_post";
                        if (["post"].includes(data.sel_type)) data.is_post = true;
                        if (data.typeQQ === "slat_post_footing") item.sel_type = "slat_post_footing";
                        if (["post_footing"].includes(data.sel_type)) data.is_footing = true;
                        if (["downpipe"].includes(data.sel_type)) {
                            data.is_downpipe = true;
                            if (!data.ref) data.ref = "Auto";
                        }
                        if (data.flashing == 1 && !data.sel_type) data.sel_type = "flashing";
                        if (data.riser && !data.sel_type) data.sel_type = "riser_bracket";
                        if (["attachment_fascia", "attachment_gutter"].includes(data.typeQQ))
                            data.sel_type = data.typeQQ;

                        BABYLON.Tags.AddTagsTo(mesh, data.sel_type);
                        if (data.typeQQ) BABYLON.Tags.AddTagsTo(mesh, data.typeQQ);
                        if (data.underside === "") {
                            if (data.sel_type === "infill_1") BABYLON.Tags.AddTagsTo(mesh, "infill_1_underside");
                            else if (data.sel_type === "infill_2") BABYLON.Tags.AddTagsTo(mesh, "infill_2_underside");
                            else BABYLON.Tags.AddTagsTo(mesh, "underside");
                        }
                        if (data.is_gutter_face) BABYLON.Tags.AddTagsTo(mesh, "gutter_face");
                        mesh.data = data;
                    } else {
                        let this_data = mesh.id.substring(ind, mesh.id.length);
                        let data_split = this_data.split(" ");
                        let data = {};

                        for (var item of data_split) {
                            let item_split = item.split("_");
                            if (item_split[0] === "area") {
                                data["areaNumber"] = item_split.length > 1 ? Number(item_split[1]) : 1;
                                data["areaIndex"] = item_split.length > 1 ? Number(item_split[1]) - 1 : 0;
                            } else if (item_split[0] === "sheet") data.sel_type = "sheet";
                            else if (item_split[0] === "beam4") data.sel_type = "beam4";
                            else if (item_split[0] === "beam3") data.sel_type = "beam3";
                            else if (item_split[0] === "LeftBeam") data.sel_type = "beam2";
                            else if (item_split[0] === "RightBeam") data.sel_type = "beam2";
                            else if (item_split[0] === "beam2") data.sel_type = "beam2";
                            else if (item_split[0] === "beam1") data.sel_type = "beam1";
                            else if (item_split[0] === "beam") {
                                data.sel_type = "beam";
                                if (item_split.length > 1) {
                                    data.beam_name = item_split[1];
                                }
                            } else if (item_split[0] === "attachment") data.sel_type = "attachment";
                            else if (item_split[0] === "attachment_roof") data.sel_type = "attachment_roof";
                            else if (item_split[0] === "gutter") data.sel_type = "gutter";
                            else if (item_split[0] === "barge") data.sel_type = "barge";
                            else if (item_split[0] === "ridge") data.sel_type = "ridge";
                            else if (item === "slat_panel") data.sel_type = "slat_panel";
                            else if (item_split[0] === "slat" && item_split?.[1] === "post")
                                data.sel_type = "slat_post";
                            else if (item_split[0] === "infill") {
                                if (item_split.length > 2 && item_split[2] === "1") data.sel_type = "infill_1";
                                if (item_split.length > 2 && item_split[2] === "2") data.sel_type = "infill_2";
                                else data.sel_type = "infill_1";
                            } else data[item_split[0]] = item_split.length > 1 ? item_split[1] : item_split[0];
                        }
                        if (data.sel_type === "beam") data.is_beam = true;
                        if (["sheet", "skylight"].includes(data.sel_type)) data.is_roofsheet = true;
                        if (
                            data.is_roofsheet &&
                            mesh.material.ambientColor.r === 1 &&
                            mesh.material.ambientColor.g === 1 &&
                            mesh.material.ambientColor.b === 1
                        ) {
                            data.sel_type = "skylight";
                        }

                        if (data.flashing == 1 && !data.sel_type) data.sel_type = "flashing";
                        if (data.riser && !data.sel_type) data.sel_type = "riser_bracket";
                        if (["skylight"].includes(data.sel_type)) data.is_skylight = true;
                        if (["attachment"].includes(data.sel_type)) data.is_attachment = true;
                        if (["slat_panel"].includes(data.sel_type)) data.is_slat = true;
                        if (["brace"].includes(data.sel_type)) data.is_brace = true;
                        if (["gutter"].includes(data.sel_type)) data.is_gutter = true;
                        if (data.is_gutter && mesh?.material?.ambientTexture?.url.includes("gutter_d.jpg")) {
                            data.is_gutter_face = true;
                        }
                        if (data?.sel_type && data.sel_type.includes("infill")) data.is_infill = true;
                        if (["barge"].includes(data.sel_type)) data.is_barge = true;
                        if (["ridge"].includes(data.sel_type)) data.is_ridge = true;
                        BABYLON.Tags.AddTagsTo(mesh, data.sel_type);
                        if (data.typeQQ) BABYLON.Tags.AddTagsTo(mesh, data.typeQQ);
                        if (data.underside === "") {
                            if (data.sel_type === "infill_1") BABYLON.Tags.AddTagsTo(mesh, "infill_1_underside");
                            else if (data.sel_type === "infill_2") BABYLON.Tags.AddTagsTo(mesh, "infill_2_underside");
                            else BABYLON.Tags.AddTagsTo(mesh, "underside");
                        }
                        if (data.is_gutter_face) BABYLON.Tags.AddTagsTo(mesh, "gutter_face");
                        mesh.data = data;
                    }

                    if (mesh.material && mesh.material.ambientTexture && mesh.material.ambientTexture.url) {
                        var filename = mesh.material.ambientTexture.url.replace(/^.*[\\\/]/, "");
                        // if (mesh.data && mesh.data.is_attachment) filename = "brick_blonde.jpg";
                        var texturePath = "models/textures/" + filename;
                        mesh.material.ambientTexture = new Texture(BaseURL(texturePath), scene);
                        mesh.material.diffuseTexture = new Texture(BaseURL(texturePath), scene);
                    }

                    // if (mesh.data.is_roofsheet) {
                    // mesh.material = Texture.Parse(mesh.material, scene, "models/");
                    // mesh.material.ambientTexture = new Texture("models/ZMM_hideck.png", scene);
                    // mesh.material.diffuseTexture = new Texture("models/ZMM_hideck.png", scene);
                    // console.log("roofsheet", mesh.material.ambientTexture);
                    // console.log("roofsheet", mesh.material.ambientTexture);
                    // mesh.material.Texture = new Texture("models/ZMM_cdeck_normal.png", scene);
                    // mesh.material.reflectionTexture = new CubeTexture("textures/skybox", scene);
                    // mesh.material.reflectionTexture.coordinatesMode = Texture.CUBIC_MODE;
                    // mesh.material.reflectionTexture.level = 0.0001;
                    // mesh.material.bumpTexture = new Texture("models/ZMM_cdeck_normal.png", scene);
                    // mesh.material.useParallax = true;
                    // mesh.material.useParallaxOcclusion = true;
                    // mesh.material.parallaxScaleBias = 0.5;
                    // }

                    // var ind = mesh.id.indexOf("area_");
                    // if (ind === -1)  ind = mesh.id.indexOf("area:");
                    // if (ind > -1) mesh.areaIndex = Number(mesh.id.substring(ind+5,ind+7).trim().replace(",",""))-1;
                    // else mesh.areaIndex = 0;

                    if (!mesh.material.metadata) mesh.material.metadata = { last_alpha: mesh.material.alpha };

                    // mesh.enableEdgesRendering(0.999);
                    // mesh.edgesColor = new window.BABYLON.Color4(0.2, 0.2, 0.2, 0.4);
                    // mesh.edgesWidth = 100;
                    mesh.actionManager = new ActionManager(scene);
                    makeOverOut(mesh);

                    shadowGenerator.addShadowCaster(mesh);
                    // shadowGenerator_torch.addShadowCaster(mesh);
                }
                floor.backFaceCulling = true;
                floor.material.backFaceCulling = true;
                // BabylonFunctions.updateMeshMode(_scene_data.gazebo_meshes, VERANDAH_MESH_MODE, VERANDAH_EDGE_LINE_MODE);

                meshes.forEach(function (el) {
                    el.isVisible = true;
                });

                elements_to_dispose.forEach(function (el) {
                    el.isVisible = false;
                    el.dispose();
                });

                load_Plan(floor_group);
                updateColours(true);

                const threeDMode = window.app.designer.threeDMode;
                if (threeDMode) {
                    scene.getEngine().runRenderLoop(() => {
                        if (typeof onRender === "function") {
                            onRender(scene, dispatch);
                        }
                        scene.render();
                    });
                }
                _scene_data.loading = false;
            } catch (err) {
                console.log("Error Loading Mesh", err.message);
                console.log(err);
                _scene_data.loading = false;
                onError();

                const threeDMode = window?.app?.designer?.threeDMode;
                if (threeDMode) {
                    console.log("bbylon started");
                    scene.getEngine().runRenderLoop(() => {
                        if (typeof onRender === "function") {
                            onRender(scene, dispatch);
                        }
                        scene.render();
                    });
                }
            }
        },
        null,
        onError
    );
};

const makeOverOut = (mesh) => {
    // mesh.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOutTrigger, mesh.material, "emissiveColor", mesh.material.emissiveColor));
    // mesh.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOverTrigger, mesh.material, "emissiveColor", new BABYLON.Color3(mesh.material.ambientColor.r * 1.0, mesh.material.ambientColor.g * 1.0, mesh.material.ambientColor.b * 1.0)));
    // mesh.actionManager.registerAction(new BABYLON.SetValueAction(BABYLON.ActionManager.OnPointerOverTrigger, mesh.material, "emissiveColor", new BABYLON.Color3(0.25, 0.25, 0.35)));
    mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function () {
            // mesh.enableEdgesRendering(0.999);
            // mesh.edgesColor = new BABYLON.Color4(1, 1, 1, 1);
            // mesh.edgesWidth = 400;

            if (_scene_data && _scene_data.loading) {
                return;
            }
            // if (mesh.data && mesh.data.alpha) mesh.material.alpha = mesh.data.alpha;

            if (_scene_data.mesh_picked && _scene_data.mesh_picked === mesh) return;

            if (mesh.material.alpha < 0.9) {
                if (mesh.metadata) {
                    if (mesh.metadata.last_edgeRendererEnabled) mesh.enableEdgesRendering(0.999);
                    else mesh.disableEdgesRendering();
                    if (mesh.metadata.last_edgesColor) mesh.edgesColor = mesh.metadata.last_edgesColor;
                    if (mesh.metadata.last_edgesWidth) mesh.edgesWidth = mesh.metadata.last_edgesWidth;
                } else {
                    mesh.disableEdgesRendering();
                }
            }

            if (_scene_data.highlighter) _scene_data.highlighter.removeMesh(mesh, BABYLON.Color3.White());
        })
    );
    mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function () {
            // mesh.enableEdgesRendering(0.999);
            // mesh.edgesColor = new BABYLON.Color4(1, 1, 1, 1);
            // mesh.edgesWidth = 400;
            if (_scene_data && _scene_data.loading) {
                return;
            }
            if (_scene_data.mesh_picked && _scene_data.mesh_picked === mesh) return;

            if (_scene_data.highlighter) {
                if (mesh.material.alpha < 0.9) {
                    if (!mesh.metadata) {
                        mesh.metadata = {};
                        mesh.metadata.last_edgeRendererEnabled = mesh.edgesRenderer ? true : false;
                        mesh.metadata.last_edgesColor = mesh.edgesColor;
                        mesh.metadata.last_edgesWidth = mesh.edgesWidth;
                    }
                    mesh.enableEdgesRendering(0.999);
                    mesh.edgesColor = new BABYLON.Color4(1, 1, 1, 1);
                    mesh.edgesWidth = 600;
                }

                // if (!mesh.data.alpha) mesh.data.alpha = mesh.material.alpha;
                // mesh.material.alpha = 1;
                _scene_data.highlighter.addMesh(mesh, BABYLON.Color3.White());
            }
        })
    );
    mesh.actionManager.registerAction(
        new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function (e) {
            if (_scene_data && _scene_data.loading) {
                return;
            }
            if (_scene_data && _scene_data.display_mode && _scene_data.display_mode === "Photo") {
                return;
            }

            if (_scene_data.togglePop && mesh.data) {
                // _scene_data.togglePop(true, _scene_data.scene.pointerX, _scene_data.scene.pointerY, mesh.data);
                _scene_data.togglePop(true, e.sourceEvent.clientX, e.sourceEvent.clientY, mesh.data);
            }
            // console.log(_scene_data.mesh_picked);
            //   SetVal("selected_item", mesh.id);
            // _scene_data.handleStateChange({ selected_item: mesh.id });
            // _scene_data.update3DDesigner(APP.BABYLON_SELECTED_ITEM, mesh.id);

            // if (mesh.id === "House Roof") _scene_data.update3DDesigner(APP.DRAWER_TOOLSET_EXPANDED, "attachment_tool");
            // if (mesh.id === "group_5 group_all") _scene_data.update3DDesigner(APP.DRAWER_TOOLSET_EXPANDED, "gutters_downpipes_tool");
            // if (mesh.id.includes("beam")) _scene_data.update3DDesigner(APP.DRAWER_TOOLSET_EXPANDED, "beams_and_posts_tool");
            // if (mesh.id === "group_3 group_all") _scene_data.update3DDesigner(APP.DRAWER_TOOLSET_EXPANDED, "beams_and_posts_tool");

            if (_scene_data.mesh_picked && _scene_data.mesh_picked !== mesh) {
                if (_scene_data.highlighter) _scene_data.highlighter.removeMesh(_scene_data.mesh_picked);
                if (_scene_data.mesh_picked.material.alpha < 0.9) {
                    if (_scene_data.mesh_picked.metadata) {
                        if (_scene_data.mesh_picked.metadata.last_edgeRendererEnabled)
                            _scene_data.mesh_picked.enableEdgesRendering(0.999);
                        else _scene_data.mesh_picked.disableEdgesRendering();
                        if (_scene_data.mesh_picked.metadata.last_edgesColor)
                            _scene_data.mesh_picked.edgesColor = _scene_data.mesh_picked.metadata.last_edgesColor;
                        if (_scene_data.mesh_picked.metadata.last_edgesWidth)
                            _scene_data.mesh_picked.edgesWidth = _scene_data.mesh_picked.metadata.last_edgesWidth;
                    } else {
                        _scene_data.mesh_picked.disableEdgesRendering();
                    }
                }
                // if (_scene_data.mesh_picked.isVisible) _scene_data.mesh_picked.isPickable = true;
                // else  _scene_data.mesh_picked.isPickable = false;

                _scene_data.mesh_picked.isPickable = true;
            }

            if (mesh.material.alpha < 0.9) {
                if (!mesh.metadata) {
                    mesh.metadata = {};
                    mesh.metadata.last_edgeRendererEnabled = mesh.edgesRenderer ? true : false;
                    mesh.metadata.last_edgesColor = mesh.edgesColor;
                    mesh.metadata.last_edgesWidth = mesh.edgesWidth;
                }
                mesh.enableEdgesRendering(0.999);
                mesh.edgesColor = new BABYLON.Color4(0, 1, 0, 1);
                mesh.edgesWidth = 400;
            }
            // console.log("highlighter");
            // console.log(_scene_data.highlighter);
            if (_scene_data.highlighter) _scene_data.highlighter.addMesh(mesh, BABYLON.Color3.Green());
            // mesh.isPickable = false;
            _scene_data.join_line.linkWithMesh(mesh);
            _scene_data.join_line.isVisible = false;
            // console.log(_scene_data.scene);
            // console.log(_scene_data.scene.activeCamera);
            // console.log(_scene_data.scene.activeCameras);

            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            var activCam = _scene_data.scene.activeCamera;
            BABYLON.Animation.CreateAndStartAnimation(
                "at5",
                activCam,
                "target",
                90,
                75,
                activCam.target,
                mesh.getBoundingInfo().boundingSphere.centerWorld,
                0,
                ease
            );
            BABYLON.Animation.CreateAndStartAnimation(
                "at6",
                activCam,
                "radius",
                90,
                75,
                activCam.radius,
                activCam.radius * (activCam.radius < 1500 ? 0.99 : 0.97),
                0,
                ease
            );

            // this.flyToPosition(_scene_data.scene.activeCamera, _scene_data.scene.activeCamera.position, mesh.pivotPoint);
            // _scene_data.scene.activeCamera.setTarget(mesh);
            // label.isVisible = false;
            // text1.text = mesh.id;
            // if (mesh.id.includes("group_4")) text1.text = "Roof Sheet selected\nDouble Sided CDeck 310 - Classic Cream";
            // if (mesh.id.includes("_mm1")) text1.text = "Footings selected";
            // if (mesh.id.includes("group_5")) text1.text = "Gutters and Downpipes selected";
            // if (mesh.id.includes("group_3")) text1.text = "Posts selected";
            // if (mesh.id.includes("group_2")) text1.text = "Beams selected";
            // if (mesh.id.includes("group_1")) text1.text = "Attachment selected";

            //update tools in react
            if (_scene_data.setToolSetArea) {
                console.log("mesh", mesh);
                let normals = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
                console.log("normals", normals);

                let areaIndex = mesh.data.areaIndex ? mesh.data.areaIndex : 0;
                var tool = undefined;
                if (mesh.data.is_attachment || mesh.data.is_attachment_roof) tool = APP.ATTACHMENT_TOOL;
                if (mesh.data.is_roofsheet) tool = APP.ROOFSHEET_TOOL;
                if (mesh.data.is_barge) tool = APP.ROOFSHEET_TOOL;
                if (mesh.data.is_ridge) tool = APP.ROOFSHEET_TOOL;
                if (mesh.data.is_beam) tool = APP.BEAMS_AND_POSTS_TOOL;
                if (mesh.data.is_post) tool = APP.BEAMS_AND_POSTS_TOOL;
                if (mesh.data.is_gutter) tool = APP.GUTTERS_DOWNPIPES_TOOL;
                if (mesh.data.is_downpipe) tool = APP.GUTTERS_DOWNPIPES_TOOL;
                if (mesh.data.is_infill) tool = APP.PITCHED_GABLE_TOOL;
                if (mesh.data.typeQQ && mesh.data.typeQQ === "gutter_label") tool = APP.GUTTERS_DOWNPIPES_TOOL;

                let current_tool = (current_tool = window?.app?.designer?.designer3D[APP.DRAWER_TOOLSET_EXPANDED]);

                // if (tool && tool !== current_tool) {
                //     setTimeout(() => {
                //         _scene_data.setToolSetArea(areaIndex, tool);
                //     }, 500);
                // }
            }

            // if (mesh.id.includes("Fascia3Example")) {
            //     _scene_data.gizmo_projection.attachedMesh = mesh;
            //     _scene_data.gizmo_length.attachedMesh = mesh;
            //     _scene_data.gizmo_shift_left.attachedMesh = mesh;
            //     _scene_data.gizmo_pitch.attachedMesh = mesh;
            // }
            // else {
            //     _scene_data.gizmo_projection.attachedMesh = null;
            //     _scene_data.gizmo_length.attachedMesh = null;
            //     _scene_data.gizmo_shift_left.attachedMesh = null;
            //     _scene_data.gizmo_pitch.attachedMesh = null;
            // }
            _scene_data.mesh_picked = mesh;
        })
    );
};

const onRender = (scene, dispatch) => {
    if (setGLB && _scene_data?.scene?.importedMeshesFiles?.length > 0 && dispatch) {
        setGLB = false;
        dispatch(APP.updateDesigner(APP.THREED_MODE, false));
        dispatch(APP.updateDesigner(APP.THREED_MINI_MODE, false));
        let options = {
            shouldExportNode: function (node) {
                // console.log(node);
                // Group 6 is the floor
                // Group 7 is the footings
                // sky Removes all sky boxes
                return (
                    !node.id.includes("group_6") &&
                    !node.id.includes("sky") &&
                    !node.id.includes("group_7") &&
                    !node.id.includes("group_1") &&
                    !node.id.includes("grass") &&
                    !node.id.includes("paving") &&
                    !node.id.includes("ground") &&
                    !node.id.includes("background") &&
                    !node.id.includes("camera") &&
                    !node.id.includes("light") &&
                    !node.id.includes("floor")
                );
            },
        };

        // For output set mesh size to M
        for (var mesh of _scene_data.scene.meshes) {
            console.log(mesh.scaling);
            let currentScale = mesh.scaling;
            mesh.scaling = new Vector3(currentScale.x * 0.01, currentScale.y * 0.01, currentScale.z * 0.01);
        }

        GLTF2Export.GLBAsync(_scene_data.scene, "model", options)
            .then((g) => dispatch(updateGLB({ glb: g })))
            .then((e) => {
                // revert back to MM for engine.
                for (var mesh of _scene_data.scene.meshes) {
                    let currentScale = mesh.scaling;
                    mesh.scaling = new Vector3(currentScale.x * 100, currentScale.y * 100, currentScale.z * 100);
                }
                // clearScene(scene);
            });
    }
    if (box !== undefined) {
        var deltaTimeInMillis = scene.getEngine().getDeltaTime();

        const rpm = 10;
        box.rotation.y += (rpm / 60) * Math.PI * 2 * (deltaTimeInMillis / 1000);
    }
};

const toggleEnvironment = (mode, shadow_mode = false, adjust_position = false) => {
    if (!mode) mode = window?.app?.designer?.designer3D[APP.BACKGROUND_MODE];
    // _scene_data.skybox.isVisible = false;
    // _scene_data.skybox2.isVisible = false;
    // _scene_data.background.isVisible = false;
    _scene_data.display_mode = mode;

    if (mode === "Plain" || mode === "Sunny Background" || mode === "Cloudy Background") {
        _scene_data.skybox.isVisible = true;
        _scene_data.skybox2.isVisible = true;
        _scene_data.ground.isVisible = true;
        if (_scene_data.paving) _scene_data.paving.isVisible = true;
        _scene_data.background.isVisible = false;
        _scene_data.ground_grid.isVisible = false;
        _scene_data.grid_ground.isVisible = false;
        // if (mode === "Sunny Background" && _scene_data.skybox) {
        //     _scene_data.skybox.material.reflectionTexture = new BABYLON.CubeTexture("textures/tropical_sunny_day/TropicalSunnyDay", _scene_data.scene);
        //     _scene_data.skybox.material.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        //     _scene_data.skybox2.material.reflectionTexture = new BABYLON.CubeTexture("textures/tropical_sunny_day/TropicalSunnyDay", _scene_data.scene);
        //     _scene_data.skybox2.material.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        // }
        // else if (mode === "Cloudy Background") {
        //     _scene_data.skybox.material.reflectionTexture = new BABYLON.CubeTexture("textures/skybox", _scene_data.scene);
        //     _scene_data.skybox.material.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        //     _scene_data.skybox2.material.reflectionTexture = new BABYLON.CubeTexture("textures/skybox", _scene_data.scene);
        //     _scene_data.skybox2.material.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        // }
        // else if (mode === "Plain") {
        //     _scene_data.skybox.material.reflectionTexture = new BABYLON.CubeTexture("textures/plain/TropicalSunnyDay", _scene_data.scene);
        //     _scene_data.skybox.material.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        //     // _scene_data.skybox2.isVisible = false;
        //     _scene_data.skybox2.material.reflectionTexture = new BABYLON.CubeTexture("textures/plain/TropicalSunnyDay", _scene_data.scene);
        //     _scene_data.skybox2.material.reflectionTexture.coordinatesMode = BABYLON.Texture.SKYBOX_MODE;
        // }
    } else if (mode === "Grid") {
        _scene_data.skybox.isVisible = false;
        _scene_data.skybox2.isVisible = false;
        _scene_data.ground.isVisible = false;

        if (_scene_data.paving) _scene_data.paving.isVisible = false;
        _scene_data.background.isVisible = true;
        _scene_data.ground_grid.isVisible = true;
        _scene_data.grid_ground.isVisible = true;
    } else if (mode === "Photo") {
        if (!_scene_data.photo_background) {
            var photo_background = new BABYLON.Layer(
                "photo",
                "https://sekisuihouse.imgix.net/getmedia/17e117c1-4e00-40e7-970f-0fef1b5d2c53/caladenia-1228-vivid-hero-1000x557.jpg.aspx?auto=format",
                _scene_data.scene,
                true
            );
            _scene_data.photo_background = photo_background;

            var photo_background = new BABYLON.Layer(
                "photo",
                "https://sekisuihouse.imgix.net/getmedia/17e117c1-4e00-40e7-970f-0fef1b5d2c53/caladenia-1228-vivid-hero-1000x557.jpg.aspx?auto=format",
                _scene_data.scene,
                true
            );
            _scene_data.photo_background = photo_background;
        }

        console.log(_scene_data);
        if (shadow_mode && _scene_data.canvas && !_scene_data.photo_background_shadow) {
            var svg =
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="" viewbox="0 0 ' +
                _scene_data.canvas.width +
                " " +
                _scene_data.canvas.height +
                '" width="1710" height="966">\
        \
      <defs>\
      <filter id="f1" x="0" y="0">\
        <feGaussianBlur in="SourceGraphic" stdDeviation="15" />\
      </filter>\
    </defs>\
    <polygon points="970,550 1520,550 1520,800 1800,900 1800,1200 1350,1200 970,900" fill="#000" opacity="0.6" filter="url(#f1)"/></svg>';
            var url = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml" }));
            var photo_background_shadow = new BABYLON.Layer("photo_svg", url, _scene_data.scene, true);
            photo_background_shadow.isVisible = true;
            _scene_data.photo_background_shadow = photo_background_shadow;
        } else if (_scene_data.photo_background_shadow && !shadow_mode) {
            _scene_data.photo_background_shadow.dispose();
            _scene_data.photo_background_shadow = null;
        }
        _scene_data.join_line.isVisible = false;
        if (_scene_data.highlighter && _scene_data.mesh_picked)
            _scene_data.highlighter.removeMesh(_scene_data.mesh_picked);

        if (adjust_position) {
            if (_scene_data.verandah_meshes) {
                var ease = new BABYLON.CubicEase();
                ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                var activCam = _scene_data.scene.activeCamera;
                BABYLON.Animation.CreateAndStartAnimation(
                    "at5",
                    activCam,
                    "target",
                    90,
                    25,
                    activCam.target,
                    _scene_data.verandah_meshes[0].getBoundingInfo().boundingSphere.centerWorld,
                    0,
                    ease
                );
                BABYLON.Animation.CreateAndStartAnimation(
                    "at6",
                    activCam,
                    "beta",
                    90,
                    25,
                    activCam.beta,
                    Math.PI * 0.53,
                    0,
                    ease
                );
            }
        }
    } else {
        _scene_data.background.isVisible = true;
        if (_scene_data.photo_background_shadow) {
            _scene_data.photo_background_shadow.dispose();
            _scene_data.photo_background_shadow = null;
        }
        if (_scene_data.photo_background) {
            _scene_data.photo_background.dispose();
            _scene_data.photo_background = null;
        }
    }
};

export const WipeSkylights3D = (areaIndex = -1) => {
    let objs = [..._scene_data.scene.getMeshesByTags("skylight"), ..._scene_data.scene.getMeshesByTags("sheet")];
    console.log("WipeSkylights3D", objs);

    for (let mesh of objs) {
        let item = mesh.data;
        if (item.is_skylight && item.areaIndex !== null && (areaIndex === -1 || areaIndex === item.areaIndex)) {
            mesh.data.is_skylight = false;
        }
    }
};

export const updateSkylights3D = () => {
    let skylightsAll = GetSpecAllAreas("SKYLIGHTS", null, []);

    let objs = [..._scene_data.scene.getMeshesByTags("skylight"), ..._scene_data.scene.getMeshesByTags("sheet")];

    // console.log("updateSkylights3D", skylightsAll, objs);

    if (!objs || objs.length === 0) return false;

    for (var mesh of objs) {
        if (mesh.data) {
            mesh.data.is_skylight = false;
        }
    }

    skylightsAll.forEach(function (area_skylights, areaIndex) {
        area_skylights.forEach(function (skylight) {
            let ref = skylight.Section + "/" + skylight.Offset;
            for (var mesh of objs) {
                if (mesh.data && mesh.data.areaIndex === areaIndex) {
                    // console.log(ref + " vd " + mesh.data?.ref);
                    if (ref === mesh.data?.ref) {
                        mesh.data.is_skylight = true;
                    }
                }
            }
        });
    });
    return true;
};

export const GetSkylights = () => {
    let skylights = {};

    let objs = [..._scene_data.scene.getMeshesByTags("skylight"), ..._scene_data.scene.getMeshesByTags("sheet")];
    // console.log("SKYLIGHTS", ..._scene_data.scene.getMeshesByTags("skylight"));

    for (let mesh of objs) {
        let item = mesh.data;
        if (item.areaIndex !== null && !skylights[item.areaIndex]) skylights[item.areaIndex] = [];
        // console.log("AREA INDEX OF SKYLIGHTS", item.areaIndex, item);
        if (item.areaIndex !== null && item.is_skylight && item?.underside !== "") {
            skylights[item.areaIndex].push({
                Section: item.ref.split("/")[0],
                Offset: item.ref.split("/")[1],
            });
        }
    }
    return skylights;
};

export const updateColours = (force_update = false) => {
    _scene_data.scene.getEngine().getRenderingCanvas();

    const ATTACHMENT_MESH_MODE = window.app.designer.designer3D[APP.ATTACHMENT_MESH_MODE];
    const ROOFSHEET__MESH_MODE = window.app.designer.designer3D[APP.ROOFSHEET__MESH_MODE];
    const BEAM_AND_POST_MESH_MODE = window.app.designer.designer3D[APP.BEAM_AND_POST_MESH_MODE];
    const FOOTINGS_MESH_MODE = window.app.designer.designer3D[APP.FOOTINGS_MESH_MODE];
    const GUTTERS_AND_FLASHING_MESH_MODE = window.app.designer.designer3D[APP.GUTTERS_AND_FLASHING_MESH_MODE];
    const VERANDAH_MESH_MODE = window.app.designer.designer3D[APP.VERANDAH_MESH_MODE];
    const VERANDAH_EDGE_LINE_MODE = window.app.designer.designer3D[APP.VERANDAH_EDGE_LINE_MODE];

    if (ROOFSHEET__MESH_MODE === "Render" || force_update) {
        // console.log("UPDATING BABYLONG COLOURS");
        let roofsheet_colour_in_areas_HTML = GetRoofColoursAreasHTML();
        let roofsheet_colour_underside_in_areas_HTML = GetRoofColoursUndersideAreasHTML();

        let roofsheet_alpha_in_areas = GetSpecAllAreasAlpha(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "RoofSheetColour",
            "Clear"
        );
        let roofsheet_grouptype_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofGroupType", "");
        let roofsheet_data_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.ROOF_SHEETING, "RoofSheetData", "Clear");
        let sheet_meshes = [
            ..._scene_data.scene.getMeshesByTags("skylight"),
            ..._scene_data.scene.getMeshesByTags("sheet"),
        ];

        roofsheet_colour_in_areas_HTML.forEach(function (value, index) {
            changeMeshGroupColourAndTexture(
                sheet_meshes,
                index,
                value,
                roofsheet_alpha_in_areas[index],
                roofsheet_data_in_areas[index].texture_filename
            );
            changeMeshGroupColour(index, "back_channel", value);
            changeMeshGroupColour(index, "sheet_end", value);
            changeMeshGroupColour(index, "sheet_side", value);
        });

        let sheet_underside_meshes = [..._scene_data.scene.getMeshesByTags("underside")];
        roofsheet_colour_underside_in_areas_HTML.forEach(function (value, index) {
            changeMeshGroupColourAndTexture(
                sheet_underside_meshes,
                index,
                value,
                roofsheet_alpha_in_areas[index],
                roofsheet_data_in_areas[index].bottomside_texture_filename
                    ? roofsheet_data_in_areas[index].bottomside_texture_filename
                    : roofsheet_data_in_areas[index].texture_filename
            );
        });
        for (let mesh of sheet_underside_meshes) {
            mesh.isVisible = true;
            if (mesh?.data?.areaIndex !== undefined) {
                if (roofsheet_grouptype_in_areas[mesh?.data?.areaIndex] === "Polycarbonate") {
                    mesh.isVisible = false;
                }
            }
        }

        for (let mesh of sheet_meshes) {
            mesh.data.is_next_to_skylight = false;
            if (mesh?.data?.areaIndex !== undefined) {
                let index = mesh?.data?.areaIndex;
                if (roofsheet_grouptype_in_areas[index] === "Polycarbonate") {
                    let sheet_mesh = mesh;
                    if (roofsheet_alpha_in_areas[index] < 0.9 && sheet_mesh.data.areaIndex === index) {
                        sheet_mesh.material.diffuseTexture = new BABYLON.Texture(
                            BaseURL("models/textures/" + roofsheet_data_in_areas[index].texture_filename),
                            _scene_data.scene
                        );
                        sheet_mesh.material.diffuseTexture.hasAlpha = true;
                        sheet_mesh.material.transparencyMode = BABYLON.Material.MATERIAL_ALPHATESTANDBLEND;
                        sheet_mesh.material.useAlphaFromDiffuseTexture = true;
                        sheet_mesh.material.alphaCutOff = 0.01;
                    }
                }
            }

            let normals = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
            console.log(mesh.data.ref, normals[2]);
            if (normals[2] < 0) {
                console.log("reversing");
                //need to reverse normals  where black sheet DES-2160
                let new_normals = [];
                for (let n of normals) {
                    new_normals.push(-n);
                }
                mesh.setVerticesData(BABYLON.VertexBuffer.NormalKind, new_normals);
                mesh.updateVerticesData(BABYLON.VertexBuffer.NormalKind, new_normals);
            }
        }

        let skylight_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "SkylightColour",
            "Opal"
        );
        let skylight_alpha_in_areas = GetSpecAllAreasAlpha(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "SkylightColour",
            "Clear"
        );

        let skylights = [];
        for (let mesh of sheet_meshes) {
            if (mesh.data.is_skylight) skylights.push(mesh);
        }
        // console.log("skylights", skylights);

        let has_skylight_different_width = false;

        let skylight_end_meshes = [..._scene_data.scene.getMeshesByTags("skylight_end")];
        let skylight_side_meshes = [..._scene_data.scene.getMeshesByTags("skylight_side")];

        skylight_colour_in_areas.forEach(function (value, index) {
            // let texture = "corro_trans.png";
            changeMeshGroupColourAndTexture(
                skylights,
                index,
                value,
                skylight_alpha_in_areas[index],
                roofsheet_data_in_areas[index].skylight_texture_filename
            );
            changeMeshGroupColourAndTexture(skylight_end_meshes, index, value, skylight_alpha_in_areas[index]);
            changeMeshGroupColourAndTexture(skylight_side_meshes, index, value, skylight_alpha_in_areas[index]);

            for (var sheet_mesh of skylights) {
                let coverage = roofsheet_data_in_areas?.[sheet_mesh.data.areaIndex]?.coverage
                    ? roofsheet_data_in_areas?.[sheet_mesh.data.areaIndex]?.coverage
                    : 760;
                let skylight_spacing = roofsheet_data_in_areas?.[sheet_mesh.data.areaIndex]?.skylight_spacing
                    ? roofsheet_data_in_areas?.[sheet_mesh.data.areaIndex]?.skylight_spacing
                    : 0;

                if (
                    roofsheet_data_in_areas?.[sheet_mesh.data.areaIndex]?.skylight_coverage &&
                    roofsheet_data_in_areas?.[sheet_mesh.data.areaIndex]?.skylight_coverage != coverage
                ) {
                    has_skylight_different_width = true;
                }

                if (skylight_alpha_in_areas[index] < 0.9 && sheet_mesh.data.areaIndex === index) {
                    sheet_mesh.material.diffuseTexture = new BABYLON.Texture(
                        BaseURL("models/textures/" + roofsheet_data_in_areas[index].skylight_texture_filename),
                        _scene_data.scene
                    );
                    sheet_mesh.material.diffuseTexture.hasAlpha = true;
                    sheet_mesh.material.transparencyMode = BABYLON.Material.MATERIAL_ALPHATESTANDBLEND;
                    sheet_mesh.material.useAlphaFromDiffuseTexture = true;
                    sheet_mesh.material.alphaCutOff = 0.01;
                }

                for (var underside of sheet_underside_meshes) {
                    if (underside.data.ref === sheet_mesh.data?.ref) {
                        underside.isVisible = false;
                    }
                }

                if (skylight_spacing > 0) {
                    let ref = sheet_mesh.data?.ref.split("/");
                    let section = ref[0];
                    let offset = toNumber(ref[1]);

                    sheet_meshes.forEach(function (sheet) {
                        let ref2_split = sheet.data.ref.split("/");
                        let section2 = ref2_split[0];
                        let offset2 = toNumber(ref2_split[1]);

                        let diff = Math.abs(offset2 - offset);
                        if (section == section2 && diff > 1 && diff < coverage * (0.6 + skylight_spacing)) {
                            sheet.data.is_next_to_skylight = true;
                        }
                    });
                }
            }
            // changeMeshGroupColour(index, "skylight", value, skylight_alpha_in_areas[index]);
        });

        if (!has_skylight_different_width) updateSkylights3D(); // don't update if has_skylight_different_width = true as the drawing will update from the server
    }

    if (GUTTERS_AND_FLASHING_MESH_MODE === "Render" || force_update) {
        let ridge_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "RidgeColour",
            "Opal"
        );
        ridge_colour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "ridge", value);
        });

        let flashing_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.ROOF_SHEETING,
            "FlashingColour",
            "Opal"
        );
        flashing_colour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "barge_cap", value);
        });

        let gutter_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "GutterCol",
            "Classic Cream"
        );

        let gutter_type_in_areas = GetSpecAllAreas(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "GutterType",
            "Fascia Gutter"
        );

        gutter_colour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "gutter", value, 1, null, 1, 1, shadeColor(value, -90));

            let gutter_filename = "gutter_D.jpg";
            if (gutter_type_in_areas[index] === "Fascia Gutter") gutter_filename = "gutter_fasciagutter.jpg";
            else if (gutter_type_in_areas[index] === "OG Gutter") gutter_filename = "gutter_og.jpg";
            else if (gutter_type_in_areas[index] === "Hi Ten OG Gutter") gutter_filename = "gutter_og.jpg";
            else if (gutter_type_in_areas[index] === "Quad Gutter") gutter_filename = "gutter_quad.jpg";
            else if (gutter_type_in_areas[index] === "Urbis Gutter") gutter_filename = null;
            changeMeshGroupColour(index, "gutter_face", value, 1, gutter_filename, 1, 1, shadeColor(value, -90));
        });

        let downpipe_clour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.GUTTERS_AND_DOWNPIPES,
            "DownpipeCol",
            "Classic Cream"
        );
        downpipe_clour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "downpipe", value, 1, null, 1, 1, shadeColor(value, -90));
        });
    }

    if (BEAM_AND_POST_MESH_MODE === "Render" || force_update) {
        var beams = _scene_data.scene.getMeshesByTags("beam");
        for (var mesh of beams) {
            mesh.material.sideOrientation = BABYLON.Mesh.DOUBLESIDE;
        }

        let beam_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            "BeamCol1",
            "Classic Cream"
        );
        beam_colour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "beam", value, 1, null, 1, 1, shadeColor(value, -90));

            // downlight flashing
            changeMeshGroupColour(index, "downlight_flashing", value, 1, null, 1, 1, shadeColor(value, -90));

            // other flashings
            changeMeshGroupColour(index, "flashing", value, 1, null, 1, 1, shadeColor(value, -90));
        });

        let beam2_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            "BeamCol2",
            "Classic Cream"
        );
        beam2_colour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "beam2", value, 1, null, 1, 1, shadeColor(value, -90));
        });
        let beam3_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            "BeamCol3",
            "Classic Cream"
        );
        beam3_colour_in_areas.forEach(function (value, index) {
            changeMeshGroupColour(index, "beam3", value, 1, null, 1, 1, shadeColor(value, -90));
        });

        for (var mesh of _scene_data.scene.getMeshesByTags("beam")) {
            if (mesh?.data?.beamName && mesh?.data?.beamName.includes("Strut")) {
            } else if (
                mesh?.data?.beam_name?.startsWith &&
                mesh?.data?.beam_name.startsWith("U") &&
                mesh.data?.colour
            ) {
                changeMeshColourAndTexture(
                    mesh,
                    GetHTMLColour(mesh.data?.colour)[0],
                    1,
                    null,
                    1,
                    1,
                    shadeColor(GetHTMLColour(mesh.data?.colour)[0], -90)
                );
            }
        }

        let BEAMSPECMODIFICATIONS_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMSPECMODIFICATIONS, null, []);
        BEAMSPECMODIFICATIONS_in_areas.forEach(function (area_mods, index) {
            for (var mesh of _scene_data.scene.getMeshesByTags("beam")) {
                let data_mods = getItemFromArray(area_mods, "Ref", mesh.data?.ref, "Ref2", mesh.data?.ref2);

                if (data_mods !== null && data_mods.Colour && data_mods.Area === mesh.data.areaIndex) {
                    changeMeshColourAndTexture(
                        mesh,
                        GetHTMLColour(data_mods.Colour)[0],
                        1,
                        null,
                        1,
                        1,
                        shadeColor(GetHTMLColour(data_mods.Colour)[0], -90)
                    );
                }
            }
        });

        let post_colour_in_areas = GetSpecAllAreasColourHTML(
            BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS,
            "PostCol",
            "Classic Cream"
        );

        let post_type_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.BEAMS_AND_POSTS, "PostType", "Classic Cream");

        post_colour_in_areas.forEach(function (value, index) {
            let post_texture = null;
            if (window.LYSAGHT || post_type_in_areas[index].includes("P/C")) post_texture = "post_rhs.jpg";

            changeMeshGroupColour(index, "post", value, 1, post_texture, 1, 1, shadeColor(value, -90));
        });

        let POSTMODIFICATIONS_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.POSTMODIFICATIONS, null, []);
        POSTMODIFICATIONS_in_areas.forEach(function (area_mods, index) {
            for (var mesh of _scene_data.scene.getMeshesByTags("post")) {
                let data_mods = getItemFromArray(area_mods, "Ref", mesh.data?.ref, "Ref2", mesh.data?.ref2);
                if (data_mods !== null && data_mods.Colour) {
                    changeMeshColourAndTexture(
                        mesh,
                        GetHTMLColour(data_mods.Colour)[0],
                        1,
                        null,
                        1,
                        1,
                        shadeColor(GetHTMLColour(data_mods.Colour)[0], -90)
                    );
                }
            }
        });
    }

    changeMeshGroupColour(-1, "brace", "#bbbbbb", 1);

    if (ATTACHMENT_MESH_MODE === "Render" || force_update) {
        let attachment_RoofType = window.job?.SiteParameters?.ExistingStructure?.RoofType;
        let house_roof_texture = "corro.jpg";
        if (attachment_RoofType === "Tile") house_roof_texture = "qdrooftile.jpg";
        let attachment_roof_colour = window.job?.SiteParameters?.ExistingStructure?.RoofColour;
        if (attachment_roof_colour)
            changeMeshGroupColour(
                -1,
                "attachment_roof",
                GetHTMLColour(attachment_roof_colour)[0],
                1,
                house_roof_texture
            );
        let attachment_WallColour = window.job?.SiteParameters?.ExistingStructure?.WallColour;

        let wall_type = window.job?.SiteParameters?.ExistingStructure?.WallType;
        if (wall_type) {
            let texture = "brick_blonde.jpg";
            let uscale = 1.3;
            let vscale = 1.3;
            if (wall_type === "Blank") {
                texture = "blank.png";
                uscale = 1;
                vscale = 1;
            }
            if (wall_type === "Red Brick") {
                texture = "red_brick.png";
                uscale = 2;
                vscale = 2;
            }
            if (wall_type === "Rendered") {
                texture = "qdrender.jpg";
                uscale = 4;
                vscale = 4;
            }
            if (wall_type === "Stone") {
                texture = "stone.jpg";
                uscale = 2;
                vscale = 2;
            }
            if (wall_type === "Timber") {
                texture = "timber.jpg";
                uscale = 0.5;
                vscale = 3;
            }
            if (wall_type === "Blocks") {
                texture = "blocks.jpg";
                uscale = 4;
                vscale = 6;
            }
            changeMeshGroupColour(-1, "attachment", attachment_WallColour, 1, texture, uscale, vscale);
        }
        // update attachments
        var objs = _scene_data.scene.getMeshesByTags("attachment");
        for (var mesh of objs) {
            mesh.material.emissiveColor = window.BABYLON.Color3.FromHexString(shadeColor(attachment_WallColour, -70));
            mesh.material.specularColor = window.BABYLON.Color3.FromHexString(shadeColor(attachment_WallColour, -80));
        }

        changeMeshGroupColour(-1, "attachment_fascia", "#eaeaea", 1);

        let attachment_FloorColour = window.job?.SiteParameters?.ExistingStructure?.FloorColour;

        let floor_type = window.job?.SiteParameters?.ExistingStructure?.FloorType;
        if (floor_type) {
            let texture = "floor_paving1.jpg";
            let uscale = 3;
            let vscale = 3;
            if (floor_type === "Blank") {
                texture = "blank.png";
                uscale = 1;
                vscale = 1;
            }
            if (floor_type === "Timber") {
                texture = "floor_decking.jpg";
                uscale = 2;
                vscale = 2;
            }
            if (floor_type === "Sandstone") {
                texture = "floor_sandstone.jpg";
                uscale = 2;
                vscale = 2;
            }
            if (floor_type === "Concrete") {
                texture = "concrete.png";
                uscale = 12;
                vscale = 12;
            }
            if (_scene_data.paving)
                changeMeshColourAndTexture(_scene_data.paving, attachment_FloorColour, 1, texture, uscale, vscale);
        }
    }

    //infills
    let infill_colour_in_areas = GetSpecAllAreasColourHTML(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillColour1",
        "Plain"
    );
    let infill_display_colour_in_areas = GetSpecAllAreasColourHTML(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillDisplayColour1",
        null
    );
    let infill_alpha_in_areas = GetSpecAllAreasAlpha(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillColour1",
        "Clear"
    );
    let infill_texture_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfillTexture1", null);
    infill_colour_in_areas.forEach(function (value, index) {
        let colour = value;
        if (infill_display_colour_in_areas[index]) colour = infill_display_colour_in_areas[index];
        if (infill_texture_in_areas[index]) {
            let texture = infill_texture_in_areas[index];
            let uscale = 1;
            let vscale = uscale;
            changeMeshGroupColour(
                index,
                "infill_1",
                colour,
                infill_alpha_in_areas[index],
                texture.filename,
                uscale,
                vscale,
                shadeColor(colour, -60),
                texture.has_alpha
            );
        } else {
            changeMeshGroupColour(
                index,
                "infill_1",
                colour,
                infill_alpha_in_areas[index],
                null,
                0,
                0,
                shadeColor(colour, -60)
            );
        }
    });

    let infill_colour_underside_in_areas = GetSpecAllAreasColourHTML(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillColour1",
        null,
        true
    );
    infill_colour_underside_in_areas.forEach(function (value, index) {
        let colour = value;
        if (infill_display_colour_in_areas[index]) colour = infill_display_colour_in_areas[index];
        changeMeshGroupColour(
            index,
            "infill_1_underside",
            colour,
            infill_alpha_in_areas[index] === 1 ? 1 : 0.01,
            null,
            null,
            null,
            shadeColor(colour, -60)
        );
    });

    let infill_meshes = _scene_data.scene.getMeshesByTags("infill_1");

    for (var mesh of infill_meshes) {
        let index = mesh?.data?.areaIndex;
        if (index !== undefined && infill_texture_in_areas[index]) {
            let texture = infill_texture_in_areas[index];
            let uv = mesh.getVerticesData("uv");
            console.log("uv1", uv);
            let xscale = uv[0];
            if (xscale === 0) xscale = uv[2];
            let uscale = texture.scale_mm / xscale;
            let vscale = uscale;
            mesh.material.ambientTexture.uScale = uscale;
            mesh.material.ambientTexture.vScale = vscale;
            mesh.material.diffuseTexture.uScale = uscale;
            mesh.material.diffuseTexture.vScale = vscale;
            mesh.material.twoSidedLighting = true;

            if (texture?.reflective) {
                mesh.material.reflectionTexture = new CubeTexture(
                    BaseURL("textures/test/TropicalSunnyDay"),
                    _scene_data.scene
                );
                mesh.material.reflectionTexture.coordinatesMode = Texture.CUBIC_MODE;
                mesh.material.reflectionTexture.level = texture?.reflective;
            } else {
                mesh.material.reflectionTexture = null;
            }
        }
    }

    let infill1_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfill1", "None");
    infill1_in_areas.forEach(function (value, index) {
        if (value === "None") toggleMeshGroupVisible(index, "infill_1", false);
        else toggleMeshGroupVisible(index, "infill_1", true);
    });

    let infill2_colour_in_areas = GetSpecAllAreasColourHTML(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillColour2",
        "Plain"
    );
    let infill2_display_colour_in_areas = GetSpecAllAreasColourHTML(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillDisplayColour2",
        null
    );
    let infill2_alpha_in_areas = GetSpecAllAreasAlpha(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillColour2",
        "Clear"
    );
    let infill2_texture_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfillTexture2", null);
    infill2_colour_in_areas.forEach(function (value, index) {
        let colour = value;
        if (infill2_display_colour_in_areas[index]) colour = infill2_display_colour_in_areas[index];

        if (infill2_texture_in_areas[index]) {
            let texture = infill2_texture_in_areas[index];
            let uscale = 1;
            let vscale = uscale;
            changeMeshGroupColour(
                index,
                "infill_2",
                colour,
                infill2_alpha_in_areas[index],
                texture.filename,
                uscale,
                vscale,
                shadeColor(colour, -60),
                texture.has_alpha
            );
        } else {
            changeMeshGroupColour(
                index,
                "infill_2",
                colour,
                infill2_alpha_in_areas[index],
                null,
                1,
                1,
                shadeColor(colour, -60)
            );
        }

        // if (infill2_in_areas[index] === "None") {
        // }
    });

    let infill2_colour_underside_in_areas = GetSpecAllAreasColourHTML(
        BASIC_SPECS_SECTIONS.GABLE_PARAMETERS,
        "TrussInfillColour2",
        null,
        true
    );
    infill2_colour_underside_in_areas.forEach(function (value, index) {
        let colour = value;
        if (infill2_display_colour_in_areas[index]) colour = infill2_display_colour_in_areas[index];
        changeMeshGroupColour(
            index,
            "infill_2_underside",
            colour,
            infill2_alpha_in_areas[index] === 1 ? 1 : 0.01,
            null,
            null,
            null,
            shadeColor(colour, -60)
        );
    });

    let infill2_meshes = _scene_data.scene.getMeshesByTags("infill_2");

    for (var mesh of infill2_meshes) {
        let index = mesh?.data?.areaIndex;
        if (index !== undefined && infill2_texture_in_areas[index]) {
            let texture = infill2_texture_in_areas[index];
            let uv = mesh.getVerticesData("uv");
            console.log("uv2", uv);
            let xscale = uv[0];
            if (xscale === 0) xscale = uv[2];
            let uscale = texture.scale_mm / xscale;
            let vscale = uscale;
            mesh.material.ambientTexture.uScale = uscale;
            mesh.material.ambientTexture.vScale = vscale;
            mesh.material.diffuseTexture.uScale = uscale;
            mesh.material.diffuseTexture.vScale = vscale;
            mesh.material.twoSidedLighting = true;

            if (texture?.reflective) {
                mesh.material.reflectionTexture = new CubeTexture(
                    BaseURL("textures/test/TropicalSunnyDay"),
                    _scene_data.scene
                );
                mesh.material.reflectionTexture.coordinatesMode = Texture.CUBIC_MODE;
                mesh.material.reflectionTexture.level = texture?.reflective;
            } else {
                mesh.material.reflectionTexture = null;
            }
        }
    }

    // update slat Colours
    let SLATS_in_areas = GetSpecAllAreas("SlatPanels", null, []);
    if (SLATS_in_areas.length > 0)
        SLATS_in_areas.forEach(function (area_mods, index) {
            for (var mesh of _scene_data.scene.getMeshesByTags("slat_panel")) {
                let data_mods = getItemFromArray(area_mods, "Ref", mesh.data?.ref, "Ref2", null);
                if (data_mods !== null && data_mods.Colour) {
                    changeMeshColourAndTexture(
                        mesh,
                        GetHTMLColour(data_mods.Colour)[0],
                        1,
                        null,
                        1,
                        1,
                        shadeColor(GetHTMLColour(data_mods.Colour)[0], -90)
                    );
                } else {
                    if (mesh.data.areaIndex === index) {
                        let default_colour = area_mods?.[0]?.Colour;
                        if (default_colour) {
                            changeMeshColourAndTexture(
                                mesh,
                                GetHTMLColour(default_colour)[0],
                                1,
                                null,
                                1,
                                1,
                                shadeColor(GetHTMLColour(default_colour)[0], -90)
                            );
                        }
                    }
                }
            }
            for (var mesh of _scene_data.scene.getMeshesByTags("slat_post")) {
                let data_mods = getItemFromArray(area_mods, "P1", mesh.data?.ref, "P2", mesh.data?.ref5);
                if (data_mods !== null && data_mods.Colour) {
                    changeMeshColourAndTexture(
                        mesh,
                        GetHTMLColour(data_mods.Colour)[0],
                        1,
                        null,
                        1,
                        1,
                        shadeColor(GetHTMLColour(data_mods.Colour)[0], -90)
                    );
                } else {
                    if (mesh.data.areaIndex === index) {
                        let default_colour = area_mods?.[0]?.Colour;
                        if (default_colour) {
                            changeMeshColourAndTexture(
                                mesh,
                                GetHTMLColour(default_colour)[0],
                                1,
                                null,
                                1,
                                1,
                                shadeColor(GetHTMLColour(default_colour)[0], -90)
                            );
                        }
                    }
                }
            }
        });

    // set invisble items
    let infill2_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "TrussInfill2", "None");
    infill2_in_areas.forEach(function (value, index) {
        if (value === "None") toggleMeshGroupVisible(index, "infill_2", false);
        else toggleMeshGroupVisible(index, "infill_2", true);
    });

    //infill beams;
    let has_infill_beams_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "HasInfillBeam1", 1);
    has_infill_beams_in_areas.forEach(function (value, index) {
        if (value === 0) toggleMeshGroupVisible(index, "infill_1_beam", false);
        else toggleMeshGroupVisible(index, "infill_1_beam", true);
    });

    let has_infill2_beams_in_areas = GetSpecAllAreas(BASIC_SPECS_SECTIONS.GABLE_PARAMETERS, "HasInfillBeam2", 1);
    has_infill2_beams_in_areas.forEach(function (value, index) {
        if (value === 0) toggleMeshGroupVisible(index, "infill_2_beam", false);
        else toggleMeshGroupVisible(index, "infill_2_beam", true);
    });

    // riser brackets
    changeMeshGroupColour(
        -1,
        "riser_bracket",
        GetHTMLColour("Galvanised")[0],
        1,
        null,
        1,
        1,
        shadeColor(GetHTMLColour("Galvanised")[0], -90)
    );

    if (window.loading3d) {
        loadingMeshMode();
        return;
    } else {
        updateMeshMode();
    }

    toggleEnvironment();
};

export const toggleMeshGroupVisible = (areaIndex, sel_type, visible) => {
    var objs = _scene_data.scene.getMeshesByTags(sel_type);
    for (var mesh of objs) {
        if (mesh.data && (mesh.data.areaIndex === areaIndex || areaIndex === -1)) {
            mesh.isVisible = visible;
        }
    }
};

export const changeMeshGroupColour = (
    areaIndex,
    sel_type,
    hex_colour = null,
    alpha = 1,
    texture = null,
    uscale = 1,
    vscale = 1,
    emissive = null,
    texture_has_alpha = false
) => {
    var objs = _scene_data.scene.getMeshesByTags(sel_type);

    changeMeshGroupColourAndTexture(
        objs,
        areaIndex,
        hex_colour,
        alpha,
        texture,
        uscale,
        vscale,
        emissive,
        texture_has_alpha
    );
};

//not hex colour can accept rgba
const changeMeshGroupColourAndTexture = (
    meshes,
    areaIndex,
    hex_colour = null,
    alpha = 1,
    texture = null,
    uscale = 1,
    vscale = 1,
    emissive = null,
    texture_has_alpha = false
) => {
    var objs = meshes;

    for (var mesh of objs) {
        if (mesh.data && (mesh.data.areaIndex === areaIndex || areaIndex === -1)) {
            mesh = changeMeshColourAndTexture(
                mesh,
                hex_colour,
                alpha,
                texture,
                uscale,
                vscale,
                emissive,
                texture_has_alpha
            );
        }
    }
};

export const changeMeshColourAndTexture = (
    mesh,
    hex_colour = null,
    alpha = 1,
    texture = null,
    uscale = 0,
    vscale = 0,
    emissive = null,
    texture_has_alpha = false
) => {
    let colour = tinycolor(hex_colour);
    hex_colour = colour.toHexString();
    if (alpha == 1) alpha = colour.getAlpha();

    if (hex_colour) {
        mesh.material.ambientColor = window.BABYLON.Color3.FromHexString(hex_colour);
        mesh.material.diffuseColor = window.BABYLON.Color3.FromHexString(hex_colour);
    }
    if (alpha) {
        mesh.material.alpha = alpha;
        if (mesh?.material?.metadata?.last_alpha) mesh.material.metadata.last_alpha = alpha;
    }

    mesh.material.useAlphaFromDiffuseTexture = false;
    if (mesh.material.diffuseTexture) mesh.material.diffuseTexture.hasAlpha = false;

    if (texture) {
        var texturePath = "models/textures/" + texture;
        mesh.material.ambientTexture = new Texture(BaseURL(texturePath), _scene_data.scene);
        mesh.material.diffuseTexture = new Texture(BaseURL(texturePath), _scene_data.scene);
        if (uscale) mesh.material.ambientTexture.uScale = uscale;
        if (vscale) mesh.material.ambientTexture.vScale = vscale;
        if (uscale) mesh.material.diffuseTexture.uScale = uscale;
        if (vscale) mesh.material.diffuseTexture.vScale = vscale;

        if (texture_has_alpha) {
            mesh.material.diffuseTexture.hasAlpha = true;
            mesh.material.transparencyMode = BABYLON.Material.MATERIAL_ALPHATESTANDBLEND;
            mesh.material.useAlphaFromDiffuseTexture = true;
            mesh.material.alphaCutOff = 0.01;
        } else {
            mesh.material.useAlphaFromDiffuseTexture = false;
            mesh.material.diffuseTexture.hasAlpha = false;
        }
    }

    if (emissive) {
        let emissive_colour = tinycolor(emissive);
        emissive = emissive_colour.toHexString();
        mesh.material.specularColor = window.BABYLON.Color3.FromHexString(emissive);
        mesh.material.emissiveColor = window.BABYLON.Color3.FromHexString(emissive);
    }
    return mesh;
};

export const loadingMeshMode = () => {
    setTimeout(() => {
        var mesh;
        let ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

        _scene_data.loading = true;
        let meshes = _scene_data.loaded_meshes;

        if (meshes) {
            for (mesh of meshes) {
                // mesh.isVisible = this.state.display_3D_plan;

                if (mesh.material && !mesh.material.metadata)
                    mesh.material.metadata = { last_alpha: mesh.material.alpha };

                if (mesh.id !== "skyBox" && mesh.id !== "ground") {
                    mesh.enableEdgesRendering(0.999);

                    let ease = new BABYLON.CubicEase();
                    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                    BABYLON.Animation.CreateAndStartAnimation(
                        "at5",
                        mesh,
                        "material.alpha",
                        90,
                        25,
                        mesh?.material?.alpha ? mesh?.material?.alpha : 1,
                        0.2,
                        0,
                        ease
                    );

                    // mesh.material.alpha = 0.2;
                    mesh.edgesColor = new window.BABYLON.Color4(1.0, 0.0, 0.0, 1.0);
                    mesh.edgesWidth = 100;
                }
            }
        }
    }, 0);
};

export const updateMeshMode = () => {
    const ATTACHMENT_MESH_MODE = window.app.designer.designer3D[APP.ATTACHMENT_MESH_MODE];
    const ROOFSHEET__MESH_MODE = window.app.designer.designer3D[APP.ROOFSHEET__MESH_MODE];
    const BEAM_AND_POST_MESH_MODE = window.app.designer.designer3D[APP.BEAM_AND_POST_MESH_MODE];
    const FOOTINGS_MESH_MODE = window.app.designer.designer3D[APP.FOOTINGS_MESH_MODE];
    const GUTTERS_AND_FLASHING_MESH_MODE = window.app.designer.designer3D[APP.GUTTERS_AND_FLASHING_MESH_MODE];
    const VERANDAH_MESH_MODE = window.app.designer.designer3D[APP.VERANDAH_MESH_MODE];
    const VERANDAH_EDGE_LINE_MODE = window.app.designer.designer3D[APP.VERANDAH_EDGE_LINE_MODE];

    setTimeout(() => {
        var mesh;
        let ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

        let meshes = _scene_data.loaded_meshes;
        if (meshes) {
            for (mesh of meshes) {
                // mesh.isVisible = this.state.display_3D_plan;

                if (mesh?.material && !mesh?.material?.metadata)
                    mesh.material.metadata = { last_alpha: mesh?.material?.alpha ? mesh?.material?.alpha : 1 };
                if (mesh?.data?.sel_type) mesh.isPickable = true;

                if (VERANDAH_MESH_MODE && mesh.id !== "skyBox" && mesh.id !== "ground") {
                    mesh.enableEdgesRendering(0.999);

                    let ease = new BABYLON.CubicEase();
                    ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                    BABYLON.Animation.CreateAndStartAnimation(
                        "at5",
                        mesh,
                        "material.alpha",
                        90,
                        25,
                        mesh.material.alpha,
                        0.2,
                        0,
                        ease
                    );

                    // mesh.material.alpha = 0.2;
                    mesh.edgesColor = new window.BABYLON.Color4(0.0, 0.0, 0.0, 1.0);
                    mesh.edgesWidth = 100;
                } else if (
                    ATTACHMENT_MESH_MODE !== "Render" &&
                    mesh.data &&
                    (mesh.data.is_attachment || mesh.data.is_attachment_roof)
                ) {
                    if (ATTACHMENT_MESH_MODE === "Mesh") {
                        mesh.enableEdgesRendering(0.999);

                        let ease = new BABYLON.CubicEase();
                        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            0.2,
                            0,
                            ease
                        );

                        // mesh.material.alpha = 0.2;
                        mesh.edgesColor = new window.BABYLON.Color4(0.0, 0.0, 0.0, 1.0);
                        mesh.edgesWidth = 100;
                        mesh.isPickable = false;
                        mesh.isVisible = true;
                    } else if (ATTACHMENT_MESH_MODE === "Hidden") {
                        mesh.isVisible = false;
                    }
                } else if (
                    ROOFSHEET__MESH_MODE !== "Render" &&
                    mesh.data &&
                    (mesh.data.is_roofsheet ||
                        mesh.data.is_skylight ||
                        mesh.data.is_barge ||
                        mesh.data.is_ridge ||
                        mesh.data.is_backchannel)
                ) {
                    if (ROOFSHEET__MESH_MODE === "Mesh") {
                        mesh.enableEdgesRendering(0.999);

                        let ease = new BABYLON.CubicEase();
                        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            0.2,
                            0,
                            ease
                        );

                        // mesh.material.alpha = 0.2;
                        mesh.edgesColor = new window.BABYLON.Color4(0.0, 0.0, 0.0, 1.0);
                        mesh.edgesWidth = 100;
                        mesh.isPickable = false;
                        mesh.isVisible = true;
                    } else if (ROOFSHEET__MESH_MODE === "Hidden") {
                        mesh.isVisible = false;
                    }
                } else if (
                    BEAM_AND_POST_MESH_MODE !== "Render" &&
                    mesh.data &&
                    (mesh.data.is_beam || mesh.data.is_post)
                ) {
                    if (BEAM_AND_POST_MESH_MODE === "Mesh") {
                        mesh.enableEdgesRendering(0.999);

                        let ease = new BABYLON.CubicEase();
                        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            0.2,
                            0,
                            ease
                        );

                        // mesh.material.alpha = 0.2;
                        mesh.edgesColor = new window.BABYLON.Color4(0.0, 0.0, 0.0, 1.0);
                        mesh.edgesWidth = 100;
                        mesh.isPickable = false;
                        mesh.isVisible = true;
                    } else if (BEAM_AND_POST_MESH_MODE === "Hidden") {
                        mesh.isVisible = false;
                    }
                } else if (
                    GUTTERS_AND_FLASHING_MESH_MODE !== "Render" &&
                    mesh.data &&
                    (mesh.data.is_gutter || mesh.data.is_downpipe)
                ) {
                    if (GUTTERS_AND_FLASHING_MESH_MODE === "Mesh") {
                        mesh.enableEdgesRendering(0.999);

                        let ease = new BABYLON.CubicEase();
                        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            0.2,
                            0,
                            ease
                        );

                        // mesh.material.alpha = 0.2;
                        mesh.edgesColor = new window.BABYLON.Color4(0.0, 0.0, 0.0, 1.0);
                        mesh.edgesWidth = 100;
                        mesh.isPickable = false;
                        mesh.isVisible = true;
                    } else if (GUTTERS_AND_FLASHING_MESH_MODE === "Hidden") {
                        mesh.isVisible = false;
                    }
                } else if (FOOTINGS_MESH_MODE !== "Render" && mesh.data && mesh.data.is_footing) {
                    if (FOOTINGS_MESH_MODE === "Mesh") {
                        mesh.enableEdgesRendering(0.999);

                        let ease = new BABYLON.CubicEase();
                        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            0.2,
                            0,
                            ease
                        );

                        // mesh.material.alpha = 0.2;
                        mesh.edgesColor = new window.BABYLON.Color4(0.0, 0.0, 0.0, 1.0);
                        mesh.edgesWidth = 100;
                        mesh.isPickable = false;
                        mesh.isVisible = true;
                    } else if (FOOTINGS_MESH_MODE === "Hidden") {
                        mesh.isVisible = false;
                    }
                } else if (VERANDAH_EDGE_LINE_MODE) {
                    // mesh.isVisible = true;
                    mesh.enableEdgesRendering(0.999);
                    mesh.edgesColor = new window.BABYLON.Color4(0.2, 0.2, 0.2, 0.7);
                    BABYLON.Animation.CreateAndStartAnimation(
                        "at5",
                        mesh,
                        "edgesWidth",
                        90,
                        25,
                        mesh.edgesWidth,
                        200,
                        0,
                        ease
                    );
                    if (mesh.material.metadata && mesh.material.metadata.last_alpha) {
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            mesh.material.metadata.last_alpha,
                            0,
                            ease
                        );
                        // mesh.material.alpha = mesh.material.metadata.last_alpha;
                    }
                } else {
                    // mesh.isVisible = true;
                    mesh.edgesColor = new window.BABYLON.Color4(0.2, 0.2, 0.2, 0.5);
                    BABYLON.Animation.CreateAndStartAnimation(
                        "at5",
                        mesh,
                        "edgesWidth",
                        90,
                        25,
                        mesh.edgesWidth,
                        0,
                        0,
                        ease
                    );
                    if (mesh?.material?.metadata && mesh.material.metadata.last_alpha) {
                        BABYLON.Animation.CreateAndStartAnimation(
                            "at5",
                            mesh,
                            "material.alpha",
                            90,
                            25,
                            mesh.material.alpha,
                            mesh.material.metadata.last_alpha,
                            0,
                            ease
                        );
                        // mesh.material.alpha = mesh.material.metadata.last_alpha;
                    }
                    mesh.disableEdgesRendering();
                }
            }
        }
    }, 0);
};

function createTreeQQ() {
    var scene = _scene_data.scene;
    ///TREES
    //leaf material
    var green = new BABYLON.StandardMaterial("green", scene);
    green.diffuseColor = new BABYLON.Color3(0.5, 0.7, 0.3);

    //trunk and branch material
    var bark = new BABYLON.StandardMaterial("bark", scene);
    // bark.emissiveTexture = new window.BABYLON.Texture("https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Bark_texture_wood.jpg/800px-Bark_texture_wood.jpg", scene);
    bark.ambientTexture = new BABYLON.Texture(BaseURL("textures/treebark.png"), scene);
    // bark.diffuseTexture = new window.BABYLON.Texture("https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Bark_texture_wood.jpg/800px-Bark_texture_wood.jpg", scene);
    bark.ambientTexture.uScale = 5.0; //Repeat 5 times on the Vertical Axes
    bark.ambientTexture.vScale = 3.0; //Repeat 5 times on the Horizontal Axes
    bark.specularColor = new BABYLON.Color3(0, 0, 0);

    //Tree parameters
    var trunk_height = 20;
    var trunk_taper = 0.6;
    var trunk_slices = 5;
    var boughs = 2; // 1 or 2
    var forks = 4;
    var fork_angle = Math.PI / 4;
    var fork_ratio = 2 / (1 + Math.sqrt(5)); //PHI the golden ratio
    var branch_angle = Math.PI / 3;
    var bow_freq = 2;
    var bow_height = 3.5;
    var branches = 10;
    var leaves_on_branch = 5;
    var leaf_wh_ratio = 0.5;

    return createTree(
        trunk_height,
        trunk_taper,
        trunk_slices,
        bark,
        boughs,
        forks,
        fork_angle,
        fork_ratio,
        branches,
        branch_angle,
        bow_freq,
        bow_height,
        leaves_on_branch,
        leaf_wh_ratio,
        green,
        scene
    );
}

export function toggleEaseInOutMeshes(meshes, visibility) {
    // animate
    setTimeout(() => {
        var mesh;
        if (!Array.isArray(meshes)) {
            meshes = [meshes];
        }
        if (meshes) {
            for (mesh of meshes) {
                if (_scene_data.mesh_picked === mesh) {
                    _scene_data.mesh_picked = null;
                    _scene_data.join_line.linkWithMesh(null);
                    _scene_data.join_line.isVisible = false;
                }

                if (visibility === true) {
                    if (!mesh.material) mesh.material = new BABYLON.StandardMaterial("myMaterial", _scene_data.scene);
                    mesh.material.alpha = 0.0;
                    mesh.isVisible = true;
                }

                mesh.isPickable = visibility;

                var ease = new BABYLON.CubicEase();
                ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                if (!visibility) {
                    BABYLON.Animation.CreateAndStartAnimation("at5", mesh, "material.alpha", 90, 25, 1.0, 0, 0, ease);
                    // BABYLON.Animation.CreateAndStartAnimation('at5', mesh, 'position.y', 90, 25, mesh.position.y-100, mesh.position.y, 0, ease);
                } else {
                    let target_alpha = 1.0;
                    if (mesh.material && mesh.material.metadata && mesh.material.metadata.last_alpha)
                        target_alpha = mesh.material.metadata.last_alpha;
                    BABYLON.Animation.CreateAndStartAnimation(
                        "at5",
                        mesh,
                        "material.alpha",
                        90,
                        25,
                        0,
                        target_alpha,
                        0,
                        ease
                    );
                    BABYLON.Animation.CreateAndStartAnimation(
                        "at5",
                        mesh,
                        "position.y",
                        90,
                        25,
                        mesh.position.y + 200,
                        mesh.position.y,
                        0,
                        ease
                    );
                }
            }
        }
    }, 0);
    setTimeout(() => {
        var mesh;
        if (meshes) {
            for (mesh of meshes) {
                if (mesh.material.metadata && mesh.material.metadata.last_alpha) {
                    mesh.material.alpha = mesh.material.metadata.last_alpha;
                }
                mesh.isVisible = visibility;
            }
        }
    }, 500);
}

export function addObject(object_name, id) {
    var scene = _scene_data.scene;
    var added_objects = _scene_data.added_objects;
    if (object_name === "Lounge") {
        window.BABYLON.SceneLoader.ImportMesh(null, "models/low_poly_couch/", "scene.gltf", scene, function (meshes) {
            var lounge = new window.BABYLON.Mesh(id, scene);

            for (var mesh of meshes) {
                // new_object_mesh.receiveShadows = true;
                mesh.parent = lounge;
                // new_object_mesh.id = id;
            }
            lounge.scaling = new window.BABYLON.Vector3(40, 40, 40);
            lounge.position = new window.BABYLON.Vector3(80, -120, 640);
            lounge.rotate(window.BABYLON.Axis.Z, -(Math.PI / 2), window.BABYLON.Space.WORLD);
            lounge.rotate(window.BABYLON.Axis.Y, -(Math.PI / 2), window.BABYLON.Space.WORLD);
            // shadowGenerator.addShadowCaster(bbq);
            var pointerDragBehavior = new window.BABYLON.PointerDragBehavior({
                dragPlaneNormal: new window.BABYLON.Vector3(0, 1, 0),
            });
            lounge.addBehavior(pointerDragBehavior);
            added_objects.push(lounge);
        });
    } else if (object_name === "Webber") {
        window.BABYLON.SceneLoader.ImportMesh(null, "models/", "webber.obj", scene, function (meshes) {
            var bbq = new window.BABYLON.Mesh(id, scene);

            for (var mesh of meshes) {
                // new_object_mesh.receiveShadows = true;
                if (mesh.id === "black_gloss_paint" || mesh.id === "black_matte_plastic") {
                    var gloss_black = new window.BABYLON.StandardMaterial("myMaterial", scene);
                    gloss_black.ambientColor = window.BABYLON.Color3.Black;
                    mesh.material = gloss_black;
                }
                mesh.parent = bbq;
                // new_object_mesh.id = id;
            }
            bbq.scaling = new window.BABYLON.Vector3(3, 3, 3);
            bbq.position = new window.BABYLON.Vector3(20, -120, 640);
            toggleEaseInOutMeshes(bbq, true);
            _scene_data.shadowGenerator.addShadowCaster(bbq);
            var pointerDragBehavior = new window.BABYLON.PointerDragBehavior({
                dragPlaneNormal: new window.BABYLON.Vector3(0, 1, 0),
            });
            bbq.addBehavior(pointerDragBehavior);
            added_objects.push(bbq);
        });
    } else if (object_name === "Tree") {
        let new_object_mesh = createTreeQQ();
        toggleEaseInOutMeshes(new_object_mesh, true);
        new_object_mesh.scaling = new BABYLON.Vector3(10, 10, 10);
        new_object_mesh.position = new BABYLON.Vector3(-40, -120, 640);
        new_object_mesh.receiveShadows = true;
        _scene_data.shadowGenerator.addShadowCaster(new_object_mesh);
        var pointerDragBehavior = new BABYLON.PointerDragBehavior({ dragPlaneNormal: new BABYLON.Vector3(0, 1, 0) });
        new_object_mesh.addBehavior(pointerDragBehavior);
        new_object_mesh.id = id;
        added_objects.push(new_object_mesh);
    } else if (object_name === "Hills Hoist") {
        BABYLON.SceneLoader.ImportMesh(
            null,
            BaseURL("models/"),
            "Hills Hoist Clothes Line1.obj",
            scene,
            function (meshes) {
                let plane_mesh = meshes.find((x) => x.id.includes("Plane"));
                if (plane_mesh) {
                    meshes = meshes.filter((item) => item !== plane_mesh);
                    plane_mesh.dispose();
                }
                // var hills_hoist = new window.BABYLON.Mesh(id,scene);
                // for (mesh of meshes) {
                //   mesh.parent = hills_hoist;
                //   mesh.receiveShadows = true;
                // };
                let hills_hoist = BABYLON.Mesh.MergeMeshes(meshes);

                hills_hoist.scaling = new BABYLON.Vector3(25, 25, 25);
                hills_hoist.position = new BABYLON.Vector3(20, -120, 640);
                toggleEaseInOutMeshes(hills_hoist, true);
                hills_hoist.receiveShadows = true;

                hills_hoist.microSurface = 0.96;
                hills_hoist.reflectivityColor = new BABYLON.Color3(0.85, 0.85, 0.85);
                hills_hoist.albedoColor = new BABYLON.Color3(0.01, 0.01, 0.01);

                _scene_data.shadowGenerator.addShadowCaster(hills_hoist);
                var pointerDragBehavior = new BABYLON.PointerDragBehavior({
                    dragPlaneNormal: new BABYLON.Vector3(0, 1, 0),
                });
                hills_hoist.addBehavior(pointerDragBehavior);

                // var pbr = new BABYLON.PBRMetallicRoughnessMaterial("pbr", scene);
                // hills_hoist.material = pbr;

                // pbr.baseColor = new BABYLON.Color3(0.5, 0.5, 0.5);
                // pbr.metallic = 0.5;
                // pbr.roughness = 0.5;
                // pbr.environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("https://www.babylonjs-playground.com/textures/environment.dds", scene);
                // pbr.metallicRoughnessTexture = new BABYLON.Texture("https://www.babylonjs-playground.com/textures/mr.jpg", scene);

                console.log(hills_hoist);
                hills_hoist.id = id;
                added_objects.push(hills_hoist);
            }
        );
    }
}

export default (props) => {
    const dispatch = useDispatch();
    _scene_data.togglePop = props.togglePop;
    _scene_data.setToolSetArea = props.setToolSetArea;
    _scene_data.uploadDocument = (name, filename, data) => {
        dispatch(uploadDocument(name, filename, data));
    };
    _scene_data.SHOW_GROUND_PHOTO = props.app.designer.designer3D[APP.SHOW_GROUND_PHOTO];

    return (
        <div>
            <Babylon3DScene
                {...props}
                antialias
                engineOptions={{ preserveDrawingBuffer: true, stencil: true }}
                onSceneReady={onSceneReady}
                onRender={onRender}
                onLoadModel={onLoadModel}
                changeMeshGroupColour={changeMeshGroupColour}
                updateColours={updateColours}
                id="my-canvas"
                // adaptToDeviceRatio={props.adaptToDeviceRatio}
                // threeDMode={props.threeDMode}
                // modelFileName={props.modelFileName}
                // backgroundMode={props.backgroundMode}
                toggleEnvironment={toggleEnvironment}
            />
        </div>
    );
};
